export const Units = Object.freeze({
  BOCAIUVA_13_29: {
    name: 'Bocaiuva',
    unitId: '29',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAMPINAS_13_30: {
    name: 'Campinas',
    unitId: '30',
    serviceDesk: '9',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADECARLOSDECARVALHO_10_120: {
    name: 'ALVARO - UNIDADE CARLOS DE CARVALHO',
    unitId: '120',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  ALVARO_UNIDADEERECHIM_10_121: {
    name: 'ALVARO - UNIDADE ERECHIM',
    unitId: '121',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEGREEN_10_122: {
    name: 'ALVARO - UNIDADE GREEN',
    unitId: '122',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  HIPERMUFFATO_10_123: {
    name: 'Hiper Muffato',
    unitId: '123',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEIRANI_10_124: {
    name: 'ALVARO - UNIDADE IRANI',
    unitId: '124',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEMATERNOINFANTIL_10_125: {
    name: 'ALVARO - UNIDADE MATERNO INFANTIL',
    unitId: '125',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEMINASGERAIS_10_127: {
    name: 'ALVARO - UNIDADE MINAS GERAIS',
    unitId: '127',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEMUFATTAO_NEVA__10_128: {
    name: 'ALVARO - UNIDADE MUFATTAO (NEVA)',
    unitId: '128',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  DUQUEDECAXIAS_CONDEPORTOALEGRE_24_232: {
    name: 'Duque de Caxias - Conde Porto Alegre',
    unitId: '232',
    serviceDesk: '8',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_SHOPPINGITABORAI_24_234: {
    name: 'SF-SHOPPING ITABORAI',
    unitId: '234',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  MARICA_24_236: {
    name: 'MARICA',
    unitId: '236',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_MARICA_24_236: {
    name: 'SF-MARICA',
    unitId: '236',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_NOVAIGUACU_DRTHIBAU_24_240: {
    name: 'Sf-nova Iguacu-dr Thibau',
    unitId: '240',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PETROPOLIS_24_242: {
    name: 'Petrópolis',
    unitId: '242',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BARRA_MDX_24_246: {
    name: 'Barra - MDX',
    unitId: '246',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=246&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BARRASHOPPING_24_250: {
    name: 'Barra Shopping',
    unitId: '250',
    serviceDesk: '10',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BONSUCESSO_NOVAYORK_24_252: {
    name: 'Bonsucesso - Nova York',
    unitId: '252',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CIDLEBLON_24_260: {
    collaboratorVaccineCampaign: true,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    name: 'CID Leblon',
    serviceDesk: '12',
    tracking: false,
    unitId: '260',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=260&campanha=hibrido&seg=vaci',
      },
    ],
  },
  NOSSASENHORADECOPACABANA_24_261: {
    collaboratorVaccineCampaign: true,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    name: 'Nossa Senhora de Copacabana',
    serviceDesk: '1',
    tracking: false,
    unitId: '261',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=261&campanha=hibrido&seg=vaci',
      },
    ],
  },
  MEIER_DIASDACRUZ_24_271: {
    name: 'Méier - Dias da Cruz',
    unitId: '271',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=271&campanha=hibrido&seg=vaci',
      },
    ],
  },
  SF_NILOPOLIS_24_273: {
    name: 'SF-NILOPOLIS',
    unitId: '273',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  SF_SHOPPINGTIJUCA_24_278: {
    name: 'SF-SHOPPING TIJUCA',
    unitId: '278',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  TIJUCA_FLORES_24_279: {
    name: 'Tijuca - Flores',
    unitId: '279',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=279&campanha=hibrido&seg=vaci',
      },
    ],
  },
  SF_SAOGONCALO_NILOPECANHA_24_287: {
    name: 'SF-SAO GONCALO-NILO PECANHA',
    unitId: '287',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  SF_SAOGONCALO_MOREIRACESAR_24_288: {
    name: 'SF-SAO GONCALO-MOREIRA CESAR',
    unitId: '288',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_SAOJOAOMERITI_24_289: {
    name: 'SF-SAO JOAO MERITI',
    unitId: '289',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_CAXIASI_3_380: {
    name: 'BRONSTEIN - CAXIAS I',
    unitId: '380',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAXIASII_3_381: {
    name: 'Caxias Ii',
    unitId: '381',
    serviceDesk: '1 a 5',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_CENTRODIAGNOSTICOITAGUAI_3_382: {
    name: 'BRONSTEIN - CENTRO DIAGNOSTICO ITAGUAI',
    unitId: '382',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_MACAE_3_383: {
    name: 'BRONSTEIN - MACAE',
    unitId: '383',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BR_NILOPOLIS_3_384: {
    name: 'BR-NILOPOLIS',
    unitId: '384',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_FONSECA_3_385: {
    name: 'BRONSTEIN - FONSECA',
    unitId: '385',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_NITEROICENTRO_3_386: {
    name: 'BRONSTEIN - NITEROI CENTRO',
    unitId: '386',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_BANGU_3_389: {
    name: 'BRONSTEIN - BANGU',
    unitId: '389',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BARRAPLAZA_3_391: {
    name: 'Barra Plaza',
    unitId: '391',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_BONSUCESSO_3_392: {
    name: 'BRONSTEIN - BONSUCESSO',
    unitId: '392',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BOTAFOGOII_3_393: {
    name: 'Botafogo Ii',
    unitId: '393',
    serviceDesk: '2 e 3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CACHAMBI_3_394: {
    name: 'Cachambi',
    unitId: '394',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_CAMPOGRANDESERIDO_3_395: {
    name: 'BRONSTEIN - CAMPO GRANDE SERIDO',
    unitId: '395',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAMPOGRANDEII_MEGAUNIDADE_3_396: {
    name: 'Campo Grande II - MegaUnidade',
    unitId: '396',
    serviceDesk: '11, 12 ou 13',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_CAMPOGRANDEWESTSHOPPING_3_397: {
    name: 'BRONSTEIN - CAMPO GRANDE WESTSHOPPING',
    unitId: '397',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CASCADURA_3_398: {
    name: 'Cascadura',
    unitId: '398',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTROI_CINELANDIA_3_400: {
    name: 'Centro I - Cinelandia',
    unitId: '400',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTROII_OUVIDOR_3_401: {
    name: 'Centro II – Ouvidor',
    unitId: '401',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  COPACABANAI_MEGAUNIDADE_3_402: {
    name: 'Copacabana I - MegaUnidade',
    unitId: '402',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=402&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BRONSTEIN_COPACABANAII_3_403: {
    name: 'BRONSTEIN - COPACABANA II',
    unitId: '403',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_GRAJAU_3_405: {
    name: 'BRONSTEIN - GRAJAU',
    unitId: '405',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_GUADALUPE_3_406: {
    name: 'BRONSTEIN - GUADALUPE',
    unitId: '406',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GUADALUPE_3_406: {
    name: 'Guadalupe',
    unitId: '406',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
  },
  ILHADOGOVERNADORII_RDI_3_408: {
    name: 'Ilha do Governador Ii - Rdi',
    unitId: '408',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=408&campanha=hibrido&seg=vaci',
      },
    ],
  },
  IPANEMA_3_409: {
    name: 'Ipanema',
    unitId: '409',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_TAQUARA_3_411: {
    name: 'BRONSTEIN - TAQUARA',
    unitId: '411',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TAQUARAOFFICE_3_412: {
    name: 'Taquara Office',
    unitId: '412',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  FREGUESIA_3_413: {
    name: 'Freguesia',
    unitId: '413',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PRACASECA_3_414: {
    name: 'Praça Seca',
    unitId: '414',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PREZUNIC_3_415: {
    name: 'Prezunic ',
    unitId: '415',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_JARDIMAMERICA_3_416: {
    name: 'BRONSTEIN - JARDIM AMÉRICA',
    unitId: '416',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_LARGODOBICAO_3_417: {
    name: 'BRONSTEIN - LARGO DO BICAO',
    unitId: '417',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LEBLON_3_418: {
    name: 'Leblon',
    unitId: '418',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MADUREIRAI_MEGAUNIDADE_3_419: {
    name: 'Madureira I - MegaUnidade',
    unitId: '419',
    serviceDesk: '1 e 2',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MADUREIRAII_SHOPPINGPOLOI_3_420: {
    name: 'Madureira II - Shopping Polo I',
    unitId: '420',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=420&campanha=hibrido&seg=vaci',
      },
    ],
  },
  MEGAMEIER_3_421: {
    name: 'Mega Meier',
    unitId: '421',
    serviceDesk: 'do 1 ao 3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=421&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BRONSTEIN_PENHA_3_423: {
    name: 'BRONSTEIN - PENHA',
    unitId: '423',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  SAOCRISTOVAO_3_427: {
    name: 'São Cristóvão',
    unitId: '427',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_SEROPEDICA_3_428: {
    name: 'BRONSTEIN - SEROPEDICA',
    unitId: '428',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_VILAISABEL_3_430: {
    name: 'BRONSTEIN - VILA ISABEL',
    unitId: '430',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_VILAVALQUEIRE_3_431: {
    name: 'BRONSTEIN - VILA VALQUEIRE',
    unitId: '431',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  AE_JARDINS_19_433: {
    name: 'AE-JARDINS',
    unitId: '433',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=433&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altajardins-rdi?d=checkin&u=433',
      },
    ],
  },
  PARQUEIBIRAPUERA_19_434: {
    name: 'PARQUE IBIRAPUERA',
    unitId: '434',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=434&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altaibirapuera-rdi?d=checkin&u=434',
      },
    ],
  },
  VILAOLIMPIA_19_435: {
    name: 'Vila Olímpia',
    unitId: '435',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=435&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altavilaolimpia-rdi?d=checkin&u=435',
      },
    ],
  },
  BARRADATIJUCA_19_436: {
    name: 'BARRA DA TIJUCA',
    unitId: '436',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altabarra-rdi2?d=checkin&u=436',
      },
    ],
  },
  BOTAFOGO_19_437: {
    name: 'BOTAFOGO',
    unitId: '437',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  ICARAI_4_438: {
    name: 'Icaraí',
    unitId: '438',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=438&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BARRASHOPPING_4_439: {
    name: 'Barra Shopping',
    unitId: '439',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BOTAFOGO_4_440: {
    name: 'Botafogo',
    unitId: '440',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAMINA_OUVIDOR_4_441: {
    name: 'LAMINA - OUVIDOR',
    unitId: '441',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: '',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=441&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LARGODOMACHADO_4_444: {
    name: 'Largo do Machado',
    unitId: '444',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MEGAUNIDADEARPOADOR_4_446: {
    name: 'Mega Unidade Arpoador',
    unitId: '446',
    serviceDesk: '8',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=446&campanha=hibrido&seg=vaci',
      },
    ],
  },
  MEGAUNIDADEBARRADATIJUCA_4_447: {
    name: 'MegaUnidade Barra da Tijuca',
    unitId: '447',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=447&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LAMINA_TIJUCA2_4_448: {
    name: 'Lamina - Tijuca 2',
    unitId: '448',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=448&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LAMINA_VOLUNTARIOSDAPATRIA_4_449: {
    name: 'Lamina - Voluntarios da Patria',
    unitId: '449',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=449&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LARGODOBICAO_24_506: {
    name: 'Largo do Bicao',
    unitId: '506',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LEBLON_19_600: {
    name: 'LEBLON',
    unitId: '600',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=600&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altaleblon-rdi2?d=checkin&u=600',
      },
    ],
  },
  HIGIENOPOLIS_19_601: {
    name: 'Higienópolis',
    unitId: '601',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=601&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altahigienopolis-rdi?d=checkin&u=601',
      },
    ],
  },
  PEIXOTOGOMIDE_19_602: {
    name: 'Peixoto Gomide',
    unitId: '602',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEANTONIORAPOSO_10_603: {
    name: 'ALVARO - UNIDADE ANTONIO RAPOSO',
    unitId: '603',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ANTONIORAPOSO_10_603: {
    name: 'Antonio Raposo',
    unitId: '603',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEVILAA_10_604: {
    name: 'ALVARO - UNIDADE VILA A',
    unitId: '604',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEREPUBLICAARGENTINA_10_605: {
    name: 'ALVARO - UNIDADE REPUBLICA ARGENTINA',
    unitId: '605',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALVARO_UNIDADEMATRIZ_10_606: {
    name: 'ALVARO - UNIDADE MATRIZ',
    unitId: '606',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_AEROPORTO_14_607: {
    name: 'ATALAIA - AEROPORTO',
    unitId: '607',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=607&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ATALAIAAEROPORTO2_14_608: {
    name: 'ATALAIA AEROPORTO 2',
    unitId: '608',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_ALTODAGLORIA_14_609: {
    name: 'ATALAIA - ALTO DA GLORIA',
    unitId: '609',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIAAPARECIDACENTRO_14_610: {
    name: 'ATALAIA APARECIDA CENTRO',
    unitId: '610',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIABELAVISTA_14_611: {
    name: 'ATALAIA BELA VISTA',
    unitId: '611',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=611&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ATALAIA_BUENOT4_14_612: {
    name: 'ATALAIA - BUENO T4',
    unitId: '612',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_VILABRASILIA_14_613: {
    name: 'ATALAIA - VILA BRASILIA',
    unitId: '613',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas.',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=613&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ATALAIANOVASUICA_14_614: {
    name: 'ATALAIA NOVA SUICA',
    unitId: '614',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_PLAZAD_ORO_14_615: {
    name: 'ATALAIA - PLAZA D_ORO',
    unitId: '615',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUL_14_616: {
    name: 'Sul',
    unitId: '616',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIATRINDADE_14_618: {
    name: 'ATALAIA TRINDADE',
    unitId: '618',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_JARDINSVIENA_14_619: {
    name: 'ATALAIA - JARDINS VIENA',
    unitId: '619',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIA_CATEDRAL_14_620: {
    name: 'ATALAIA - CATEDRAL',
    unitId: '620',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIACIDADEJARDIM_14_621: {
    name: 'ATALAIA CIDADE JARDIM',
    unitId: '621',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  COIMBRA_14_622: {
    name: 'Coimbra',
    unitId: '622',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ATALAIAELDORADO_14_623: {
    name: 'ATALAIA ELDORADO',
    unitId: '623',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MARISTA_14_625: {
    name: 'Marista',
    unitId: '625',
    serviceDesk: '4 ou 7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=625&campanha=digital&seg=vaci',
      },
    ],
  },
  CEDIC_BARAO_20_632: {
    name: 'Cedic - Barao',
    unitId: '632',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
  },
  CEDIC_JARDIMDASAMERICAS_20_633: {
    name: 'Cedic - Jardim das Americas',
    unitId: '633',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=633&campanha=hibrido&seg=vaci',
      },
    ],
  },
  CEDILAB_BARAO_21_634: {
    name: 'Cedilab - Barão',
    unitId: '634',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=634&campanha=hibrido&seg=vaci',
      },
    ],
  },
  CEDILAB_JARDIMDASAMERICAS_21_636: {
    name: 'Cedilab - Jardim das Americas',
    unitId: '636',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
  },
  CERPE_ABDIAS_34_637: {
    name: 'CERPE - ABDIAS',
    unitId: '637',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_ABREUELIMA_34_638: {
    name: 'CERPE - ABREU E LIMA',
    unitId: '638',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_AFOGADOS_34_639: {
    name: 'CERPE - AFOGADOS',
    unitId: '639',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  AGAMENONMAGALHAES_34_640: {
    name: 'Agamenon Magalhaes',
    unitId: '640',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  X041_AVRECIFE_34_641: {
    name: 'X041 - AV RECIFE',
    unitId: '641',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_BEBERIBE_34_642: {
    name: 'Cerpe - Beberibe',
    unitId: '642',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SETUBAL_34_643: {
    name: 'Setubal',
    unitId: '643',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_REALTORRE_34_644: {
    name: 'Cerpe - Real Torre',
    unitId: '644',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_PAULISTA_34_648: {
    name: 'CERPE - PAULISTA',
    unitId: '648',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_PAULISTAII_34_649: {
    name: 'CERPE - PAULISTA II',
    unitId: '649',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_PIEDADE_34_650: {
    name: 'Cerpe - Piedade',
    unitId: '650',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_PRAZERES_34_651: {
    name: 'CERPE - PRAZERES',
    unitId: '651',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_RIODOCE_34_652: {
    name: 'CERPE - RIO DOCE',
    unitId: '652',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_SAOLOURENCO_34_653: {
    name: 'CERPE - SAO LOURENCO',
    unitId: '653',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  JABOATAO_34_654: {
    name: 'Jaboatão',
    unitId: '654',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JANGA_34_655: {
    name: 'Janga',
    unitId: '655',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_JAQUEIRA_34_656: {
    name: 'Cerpe - Jaqueira',
    unitId: '656',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_LIMOEIRO_34_657: {
    name: 'CERPE - LIMOEIRO',
    unitId: '657',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  X010_OLINDAI_34_658: {
    name: 'X010 - OLINDA I',
    unitId: '658',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_OLINDAII_34_659: {
    name: 'Cerpe - Olinda I I',
    unitId: '659',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ESPINHEIRO_34_660: {
    name: 'Espinheiro',
    unitId: '660',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_GRAVATA_34_661: {
    name: 'CERPE - GRAVATA',
    unitId: '661',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_IGARASSU_34_664: {
    name: 'CERPE - IGARASSU',
    unitId: '664',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  X017_IMBIRIBEIRA_34_665: {
    name: 'X017 - IMBIRIBEIRA',
    unitId: '665',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CARUARU_AV_AGAMEMONMAGALHAES__34_666: {
    name: 'CERPE - CARUARU (AV. AGAMEMON MAGALHAES)',
    unitId: '666',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CARUARU_RUAPARNAIBA__34_667: {
    name: 'CERPE - CARUARU (RUA PARNAIBA)',
    unitId: '667',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CASAFORTE_34_668: {
    name: 'Cerpe - Casa Forte',
    unitId: '668',
    serviceDesk: '4',
    tracking: false,
    collaboratorVaccineCampaign: true,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=668&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  CERPE_CAVALEIRO_34_669: {
    name: 'CERPE - CAVALEIRO',
    unitId: '669',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CAXANGA_34_670: {
    name: 'Cerpe - Caxanga',
    unitId: '670',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_DERBY_34_671: {
    name: 'Cerpe - Derby',
    unitId: '671',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=671&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  CERPE_BOAVIAGEMI_34_672: {
    name: 'Cerpe - Boa Viagem I',
    unitId: '672',
    serviceDesk: '4',
    tracking: false,
    collaboratorVaccineCampaign: true,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=672&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  CERPE_BOAVIAGEMII_34_673: {
    name: 'Cerpe - Boa Viagem I I',
    unitId: '673',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CABO_34_674: {
    name: 'Cabo',
    unitId: '674',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CAMARAGIBE_34_675: {
    name: 'CERPE - CAMARAGIBE',
    unitId: '675',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CANDEIAS_34_676: {
    name: 'Cerpe - Candeias',
    unitId: '676',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CARPINA_34_677: {
    name: 'Carpina',
    unitId: '677',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ARUJACENTRO_27_678: {
    name: 'Aruja Centro',
    unitId: '678',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_FERRAZDEVASCONCELOS_27_679: {
    name: 'CYTOLAB - FERRAZ DE VASCONCELOS',
    unitId: '679',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_GUARAREMA_27_680: {
    name: 'CYTOLAB - GUARAREMA',
    unitId: '680',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_ITAQUAQUECETUBA_27_681: {
    name: 'CYTOLAB - ITAQUAQUECETUBA',
    unitId: '681',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MOGISHOPPING_27_684: {
    name: 'Mogi Shopping',
    unitId: '684',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_POA_27_685: {
    name: 'CYTOLAB - POA',
    unitId: '685',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_SANTAISABEL_27_686: {
    name: 'CYTOLAB - SANTA ISABEL',
    unitId: '686',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUZANOCENTRO_27_688: {
    name: 'Suzano Centro',
    unitId: '688',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUZANOSHOPPING_27_689: {
    name: 'Suzano Shopping',
    unitId: '689',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRASCUBAS_27_690: {
    name: 'Bras Cubas',
    unitId: '690',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_CESARDESOUZA_27_691: {
    name: 'CYTOLAB - CESAR DE SOUZA',
    unitId: '691',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MATRIZJARDIMSANTISTA_27_692: {
    name: 'MATRIZ JARDIM SANTISTA',
    unitId: '692',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_JARDIMUNIVERSO_27_693: {
    name: 'CYTOLAB - JARDIM UNIVERSO',
    unitId: '693',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_JOSEBONIFACIO_27_694: {
    name: 'CYTOLAB - JOSE BONIFACIO',
    unitId: '694',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CYTOLAB_JUNDIAPEBA_27_695: {
    name: 'CYTOLAB - JUNDIAPEBA',
    unitId: '695',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALPHAVILLE_1_696: {
    name: 'Alphaville',
    unitId: '696',
    serviceDesk: '15 ou 17',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=696&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=696',
      },
    ],
  },
  ALTODEPINHEIROS_1_697: {
    name: 'Alto de Pinheiros',
    unitId: '697',
    serviceDesk: '7 ou 8',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=697&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=697',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=697',
      },
    ],
  },
  ALTODESANTANA_1_698: {
    name: 'Alto de Santana',
    unitId: '698',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=698&campanha=digital&seg=vaci',
      },
    ],
  },
  AUGUSTA_1_699: {
    name: 'Augusta',
    unitId: '699',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=699&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BRAZLEME_1_700: {
    name: 'Braz Leme',
    unitId: '700',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BROOKLIN_1_701: {
    name: 'Brooklin',
    unitId: '701',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=701&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=701',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=701',
      },
    ],
  },
  VIADUTODOCHA_1_703: {
    name: 'Viaduto do Cha',
    unitId: '703',
    serviceDesk: '3, 4, 5, ou 6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=703&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=703',
      },
    ],
  },
  VILACLEMENTINO_23DEMAIO_1_704: {
    name: 'Vila Clementino/23 de Maio',
    unitId: '704',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=704&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=704',
      },
    ],
  },
  MOOCA_1_705: {
    name: 'Mooca',
    unitId: '705',
    serviceDesk: '4 ou 6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=705&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=705',
      },
    ],
  },
  SANTOANDRE_1_706: {
    name: 'Santo André',
    unitId: '706',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=706&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=706',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=706',
      },
    ],
  },
  SANTOANDREII_1_707: {
    name: 'Santo André II',
    unitId: '707',
    serviceDesk: '1, 8 ou 9',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=707&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=707',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=707',
      },
    ],
  },
  SANTOS_1_708: {
    name: 'Santos',
    unitId: '708',
    serviceDesk: '3, 4 ou 5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=708&campanha=hibrido&seg=vaci',
      },
    ],
  },
  OSASCO_1_709: {
    name: 'Osasco',
    unitId: '709',
    serviceDesk: '3 ou 4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=709&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=709',
      },
    ],
    uploadExams: true,
  },
  SAOBERNARDODOCAMPO_1_710: {
    name: 'São Bernardo do Campo',
    unitId: '710',
    serviceDesk: '6 ou 7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=710&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=710',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=710',
      },
    ],
  },
  LAPA_1_711: {
    name: 'Lapa',
    unitId: '711',
    serviceDesk: '2 ou 7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=711',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=711',
      },
    ],
  },
  MEGAUNIDADEJARDIMSUL_1_712: {
    name: 'Megaunidade Jardim Sul',
    unitId: '712',
    serviceDesk: '2, 3 e 5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=712&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=712',
      },
    ],
  },
  MEGAUNIDADELUIZDUMONTVILARES_1_713: {
    name: 'Megaunidade Luiz Dumont Vilares',
    unitId: '713',
    serviceDesk: '4, 6 ou 7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=713&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=713',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=713',
      },
    ],
  },
  MEGAUNIDADERICARDOJAFET_1_714: {
    name: 'Megaunidade Ricardo Jafet',
    unitId: '714',
    serviceDesk: '21 ou 22',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=714&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=714',
      },
    ],
  },
  MEGAUNIDADESUMARE_1_715: {
    name: 'Megaunidade Sumaré',
    unitId: '715',
    serviceDesk: '10',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=715&campanha=digital&seg=vaci',
      },
    ],
  },
  MEGAUNIDADETATUAPE_1_716: {
    name: 'Megaunidade Tatuapé',
    unitId: '716',
    serviceDesk: '1 ou 2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=716&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=716',
      },
    ],
  },
  CHACARAFLORA_1_717: {
    name: 'Chácara Flora',
    unitId: '717',
    serviceDesk: '5 ou 6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=717&campanha=digital&seg=vaci',
      },
    ],
  },
  GRANJAVIANA_1_718: {
    name: 'Granja Viana',
    unitId: '718',
    serviceDesk: '7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=718&campanha=digital&seg=vaci',
      },
    ],
  },
  GUARULHOS_1_720: {
    name: 'Guarulhos',
    unitId: '720',
    serviceDesk: '1 ou 3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=720&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=720',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=720',
      },
    ],
  },
  ITAIMBIBI_1_722: {
    name: 'Itaim Bibi',
    unitId: '722',
    serviceDesk: '7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=722&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=722',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=722',
      },
    ],
  },
  D724AFONSOPENA_8_782: {
    name: 'D724 AFONSO PENA',
    unitId: '782',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AGUAVERDE_8_783: {
    name: 'Agua Verde',
    unitId: '783',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AHU_8_784: {
    name: 'Ahu',
    unitId: '784',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALTODAXV_8_785: {
    name: 'Alto da XV',
    unitId: '785',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=785&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  D059_FSALTOMARACANA_8_786: {
    name: 'D059 - FS ALTO MARACANA',
    unitId: '786',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D261_ARAUCARIA_8_787: {
    name: 'D261 - ARAUCÁRIA',
    unitId: '787',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D716_SITIOCERCADO_8_789: {
    name: 'D716 - SITIO CERCADO',
    unitId: '789',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D268_TARUMA_8_790: {
    name: 'D268 - TARUMÃ',
    unitId: '790',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D228_UBERABA_8_791: {
    name: 'D228 - UBERABA',
    unitId: '791',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  XAXIM_8_792: {
    name: 'Xaxim',
    unitId: '792',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=792&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  D265_PLINIO_8_793: {
    name: 'D265 - PLÍNIO',
    unitId: '793',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D274_PORTAO_8_795: {
    name: 'D274 - PORTÃO',
    unitId: '795',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTAFELICIDADE_8_796: {
    name: 'Santa Felicidade',
    unitId: '796',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D263_SAOJOSEDOSPINHAIS_8_797: {
    name: 'D263 - SÃO JOSÉ DOS PINHAIS',
    unitId: '797',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D280_SAOMATEUSDOSUL_8_798: {
    name: 'D280 - SÃO MATEUS DO SUL',
    unitId: '798',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  FS_MERCES_8_799: {
    name: 'FS-MERCÊS',
    unitId: '799',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D279_FS_PALLADIUM_8_800: {
    name: 'D279 - FS - PALLADIUM',
    unitId: '800',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D760_FS_PILARZINHOCURITIBA_8_802: {
    name: 'D760 - FS - PILARZINHO CURITIBA',
    unitId: '802',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D759_PINHAIS_8_803: {
    name: 'D759 - PINHAIS',
    unitId: '803',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D273_PINHEIRINHO_8_804: {
    name: 'D273 - PINHEIRINHO',
    unitId: '804',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D229_FS_SHOPPINGDASAMERICAS_8_807: {
    name: 'D229 - FS - SHOPPING DAS AMÉRICAS',
    unitId: '807',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D761_FS_MATEUSLEME_8_809: {
    name: 'D761 - FS - MATEUS LEME',
    unitId: '809',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D267_CAMPOLARGO_8_811: {
    name: 'D267 - CAMPO LARGO',
    unitId: '811',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CARMO_8_812: {
    name: 'Carmo',
    unitId: '812',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  FAZENDARIOGRANDE_8_813: {
    name: 'FAZENDA RIO GRANDE',
    unitId: '813',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D272_FAZENDINHA_8_814: {
    name: 'D272 - FAZENDINHA',
    unitId: '814',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=814&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  D257_FONTANA_8_815: {
    name: 'D257 - FONTANA',
    unitId: '815',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BACACHERI_8_817: {
    name: 'Bacacheri',
    unitId: '817',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D260_BARAO_8_818: {
    name: 'D260 - BARÃO',
    unitId: '818',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D277_BARIGUI_8_819: {
    name: 'D277 - BARIGUI',
    unitId: '819',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    collaboratorVaccineCampaign: true,
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=819&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  D717_FS_POSTOBARREIRINHA_8_820: {
    name: 'D717 - FS - POSTO BARREIRINHA',
    unitId: '820',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BATEL1_8_821: {
    name: 'Batel 1',
    unitId: '821',
    serviceDesk: '16',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=821&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  D287_FS_BOAVISTA_8_822: {
    name: 'D287 - FS - BOA VISTA',
    unitId: '822',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAMPOGRANDE_12_823: {
    name: 'Campo Grande',
    unitId: '823',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ITAIGARA_12_824: {
    name: 'Itaigara',
    unitId: '824',
    serviceDesk: '1 e 5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
  },
  ONDINA_12_825: {
    name: 'Ondina',
    unitId: '825',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  VILASDOATLANTICO_12_826: {
    name: 'Vilas do Atlântico',
    unitId: '826',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_AGUIADEHAIA_2_842: {
    name: 'LAVOISIER - AGUIA DE HAIA',
    unitId: '842',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  RIONEGRO_2_843: {
    name: 'Rio Negro',
    unitId: '843',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=843&campanha=hibrido&seg=vaci',
      },
    ],
  },
  AMADORBUENO_2_844: {
    name: 'Amador Bueno',
    unitId: '844',
    serviceDesk: '14',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=844&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=844',
      },
    ],
  },
  ANGELICAI_2_845: {
    name: 'Angélica I',
    unitId: '845',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    uploadExams: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=845&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=845',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=845',
      },
    ],
  },
  ANGELICAII_2_846: {
    name: 'Angélica II',
    unitId: '846',
    serviceDesk: '9 ou 10',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=846',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=846',
      },
    ],
  },
  LAVOISIER_CAMBUCI_2_850: {
    name: 'LAVOISIER - CAMBUCI',
    unitId: '850',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_VILACARRAO_2_854: {
    name: 'LV - VILA CARRÃO',
    unitId: '854',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_CARREFOURANCHIETA_2_855: {
    name: 'LAVOISIER - CARREFOUR ANCHIETA',
    unitId: '855',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_CIDADEDUTRA_2_858: {
    name: 'LV - CIDADE DUTRA',
    unitId: '858',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  DARZAN_2_861: {
    name: 'Darzan',
    unitId: '861',
    serviceDesk: '11 e 12',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=861&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=861',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=861',
      },
    ],
  },
  DIADEMA_2_862: {
    name: 'Diadema',
    unitId: '862',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_DIADEMA_2_862: {
    name: 'LAVOISIER - DIADEMA',
    unitId: '862',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_FARIALIMA_2_865: {
    name: 'LAVOISIER - FARIA LIMA',
    unitId: '865',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  FCOMORATO_2_866: {
    name: 'Fco Morato',
    unitId: '866',
    serviceDesk: '7',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_FREGUESIADOO_2_867: {
    name: 'LAVOISIER - FREGUESIA DO O',
    unitId: '867',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_GUARULHOSII_2_874: {
    name: 'LV - GUARULHOS II',
    unitId: '874',
    serviceDesk: '7 ou 9',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=918',
      },
    ],
  },
  LV_IBIRAPUERA_2_878: {
    name: 'LV - IBIRAPUERA',
    unitId: '878',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=878&campanha=hibrido&seg=vaci',
      },
    ],
  },
  IPIRANGA_2_879: {
    name: 'Ipiranga',
    unitId: '879',
    serviceDesk: '21 ou 23',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=879&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=879',
      },
    ],
  },
  LAVOISIER_ITAIMBIBI_2_880: {
    name: 'LAVOISIER - ITAIM BIBI',
    unitId: '880',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_ITAQUERA_2_883: {
    name: 'LAVOISIER - ITAQUERA',
    unitId: '883',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_JABAQUARA_2_884: {
    name: 'LV - JABAQUARA',
    unitId: '884',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=884&campanha=digital&seg=vaci',
      },
    ],
  },
  LAVOISIER_JACANA_2_885: {
    name: 'LAVOISIER - JACANA',
    unitId: '885',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_JOAODIAS_2_886: {
    name: 'LAVOISIER - JOAO DIAS',
    unitId: '886',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_LAPAI_2_888: {
    name: 'LV - LAPA I',
    unitId: '888',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=888&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LV_LAPAII_2_889: {
    name: 'LV - LAPA II',
    unitId: '889',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_MOOCA_2_896: {
    name: 'Lavoisier - Mooca',
    unitId: '896',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_PARAISO_2_900: {
    name: 'LAVOISIER - PARAISO',
    unitId: '900',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_PENHA_2_901: {
    name: 'LV - PENHA',
    unitId: '901',
    serviceDesk: '4 ou 5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_PONTERASA_2_904: {
    name: 'LAVOISIER - PONTE RASA',
    unitId: '904',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_REPUBLICAI_2_906: {
    name: 'LAVOISIER - REPUBLICA I',
    unitId: '906',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTOAMARO_2_910: {
    name: 'Santo Amaro',
    unitId: '910',
    serviceDesk: '11 ou 12',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=910',
      },
    ],
  },
  LV_SANTOAMARO_BORBAGATO__2_911: {
    name: 'LV - SANTO AMARO (BORBA GATO)',
    unitId: '911',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=911&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=911',
      },
    ],
  },
  LAVOISIER_SAOBERNARDOPLAZASHOPPING_2_912: {
    name: 'LAVOISIER - SAO BERNARDO PLAZA SHOPPING',
    unitId: '912',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAOBERNARDOPLAZASHOPPING_2_912: {
    name: 'São Bernardo Plaza Shopping',
    unitId: '912',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  LAVOISIER_SAOCAETANODOSUL_2_913: {
    name: 'Lavoisier - Sao Caetano do Sul',
    unitId: '913',
    serviceDesk: '1 ou 2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=913&campanha=hibrido&seg=vaci',
      },
    ],
  },
  LAVOISIER_SAOMATEUS_2_914: {
    name: 'LAVOISIER - SAO MATEUS',
    unitId: '914',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_SAOMIGUEL_2_915: {
    name: 'Lavoisier - Sao Miguel',
    unitId: '915',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=715',
      },
    ],
  },
  LAVOISIER_SAPOPEMBA_2_916: {
    name: 'LAVOISIER - SAPOPEMBA',
    unitId: '916',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_SHOPPINGABC_2_917: {
    name: 'Lavoisier - Shopping Abc',
    unitId: '917',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=917',
      },
    ],
  },
  INTERLAGOSII_2_919: {
    name: 'Interlagos II',
    unitId: '919',
    serviceDesk: '23 ou 24',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=919',
      },
    ],
  },
  INTERLAGOSI_2_920: {
    name: 'Interlagos I',
    unitId: '920',
    serviceDesk: '14 ou 14',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=920&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=920',
      },
    ],
  },
  SHOPPINGARICANDUVA_2_921: {
    name: 'Shopping Aricanduva',
    unitId: '921',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=921&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=921',
      },
    ],
  },
  LV_SHOPPINGMETROSANTACRUZ_2_923: {
    name: 'LV - SHOPPING METRÔ SANTA CRUZ',
    unitId: '923',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_SHOPPINGMETROTATUAPE_2_924: {
    name: 'LV - SHOPPING METRÔ TATUAPÉ',
    unitId: '924',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_SHOPPINGPARQUEBARUERI_2_925: {
    name: 'LAVOISIER - SHOPPING PARQUE BARUERI',
    unitId: '925',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_RAPOSO_2_926: {
    name: 'LAVOISIER - RAPOSO',
    unitId: '926',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SHOPPINGTABOAO_2_927: {
    name: 'Shopping Taboão',
    unitId: '927',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=927&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=927',
      },
    ],
  },
  SHOPPINGUNIAOOSASCO_2_928: {
    name: 'Shopping União Osasco',
    unitId: '928',
    serviceDesk: '9 ou 10',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=928',
      },
    ],
  },
  LAVOISIER_GUARAPIRANGA_2_930: {
    name: 'Guarapiranga',
    unitId: '930',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_TEODOROSAMPAIO_2_931: {
    name: 'Lavoisier - Teodoro Sampaio',
    unitId: '931',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_TUCURUVI_2_932: {
    name: 'LV - TUCURUVI',
    unitId: '932',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=932',
      },
    ],
  },
  LAVOISIER_VILAFORMOSA_2_933: {
    name: 'LAVOISIER - VILA FORMOSA',
    unitId: '933',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_VILALEOPOLDINA_2_934: {
    name: 'LAVOISIER - VILA LEOPOLDINA',
    unitId: '934',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TATUAPEEUCLIDESPACHECO_2_935: {
    name: 'Tatuapé Euclides Pacheco',
    unitId: '935',
    serviceDesk: '11 e 6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=935&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=935',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=935',
      },
    ],
  },
  LAVOISIER_VILAMARIA_2_936: {
    name: 'LAVOISIER - VILA MARIA',
    unitId: '936',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_VILAMATILDE_2_937: {
    name: 'LAVOISIER - VILA MATILDE',
    unitId: '937',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_VILAPRUDENTE_2_939: {
    name: 'LAVOISIER - VILA PRUDENTE',
    unitId: '939',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_VILASABRINA_2_940: {
    name: 'LAVOISIER - VILA SABRINA',
    unitId: '940',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LV_SANTANAI_METROCARANDIRU_2_942: {
    name: 'LV - SANTANA I/METRÔ CARANDIRU',
    unitId: '942',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ADVANCE_15_1322: {
    name: 'Advance',
    unitId: '1322',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALBANY_15_948: {
    name: 'Albany',
    unitId: '948',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AGUASCLARAS_BIGBOX_15_949: {
    name: 'Aguas Claras – Big Box',
    unitId: '949',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=949&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  REAL_ESPLENDOR_15_951: {
    name: 'Real Esplendor',
    unitId: '951',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AGUAS_CLARASII_EDTURMALINA_15_952: {
    name: 'Aguas Claras II - Ed Turmalina',
    unitId: '952',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AGUASLINDAS_15_953: {
    name: 'ÁGUAS LINDAS',
    unitId: '953',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ASANORTE_LIBERTY_MALL_15_1002: {
    name: 'Asa Norte - Liberty Mall',
    unitId: '1002',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  ASA_NORTE_LACLIB_15_1001: {
    name: 'Asa Norte - Laclib',
    unitId: '1001',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ASANORTEIII_CLEOOTAVIO_15_1004: {
    name: 'Asa Norte I I I - Cleo Otavio',
    unitId: '1004',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ASA_NORTEII_15_1003: {
    name: 'Asa Norte II',
    unitId: '1003',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=1003&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ASASUL_15_996: {
    name: 'ASA SUL',
    unitId: '996',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  ASASUL_15_997: {
    name: 'ASA SUL',
    unitId: '997',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  ASASUL_15_1174: {
    name: 'Asa Sul',
    unitId: '1174',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  SETOR_COMERCIAL_SUL_15_998: {
    name: 'Setor Comercial Sul',
    unitId: '998',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CEILANDIA_CENTRO_15_1047: {
    name: 'Ceilandia Centro',
    unitId: '1047',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CEILANDIAII_15_1000: {
    name: 'CEILANDIA II',
    unitId: '1000',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CEILANDIAIII_15_1279: {
    name: 'CEILÂNDIA III ',
    unitId: '1279',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CIDADEOCIDENTAL_15_989: {
    name: 'CIDADE OCIDENTAL',
    unitId: '989',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GUARAII_ED_REALMIX_15_986: {
    name: 'Guara II - Ed. Real Mix',
    unitId: '986',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=986&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
    collaboratorVaccineCampaign: true,
  },
  EXAME_LAGOSULI_15_978: {
    name: 'Exame - Lago Sul I',
    unitId: '978',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=978&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  TAGUATINGAII_15_964: {
    name: 'Taguatinga II',
    unitId: '964',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  FORMOSA_15_991: {
    name: 'FORMOSA ',
    unitId: '991',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GAMA_15_993: {
    name: 'GAMA',
    unitId: '993',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GAMAII_15_994: {
    name: 'GAMA II',
    unitId: '994',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GRANDE_COLORADO_15_1323: {
    name: 'Grande Colorado',
    unitId: '1323',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GUARAI_OFFICE_15_983: {
    name: 'Guará I - Office',
    unitId: '983',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GUARAII_15_985: {
    name: 'Guara II',
    unitId: '985',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=985&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  JARDIM_BOTANICO_15_987: {
    name: 'Jardim Botanico',
    unitId: '987',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JARDIMINGA_15_1278: {
    name: 'JARDIM INGÁ',
    unitId: '1278',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AMBULATORIO_HOSPITAL_BRASILIA_15_977: {
    name: 'Ambulatorio Hospital Brasilia',
    unitId: '977',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SMDB_15_1281: {
    name: 'Smdb',
    unitId: '1281',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=1281&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  LAGO_SULII_15_979: {
    name: 'Lago Sul II',
    unitId: '979',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUZIANIA_15_980: {
    name: 'LUZIÂNIA',
    unitId: '980',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MEGAASANORTE_BIOSPHERE_15_981: {
    name: 'Mega Asa Norte – Biosphere',
    unitId: '981',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=981&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  MEGAASASUL_15_982: {
    name: 'Mega Asa Sul',
    unitId: '982',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=982&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  MEGATAGUATINGANORTE_15_971: {
    name: 'Mega Taguatinga Norte',
    unitId: '971',
    serviceDesk: '13',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  NUCLEOBANDEIRANTE_15_972: {
    name: 'NUCLEO BANDEIRANTE',
    unitId: '972',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PARANOA_15_973: {
    name: 'Paranoa',
    unitId: '973',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PLANALTINACENTRO_15_976: {
    name: 'PLANALTINA CENTRO ',
    unitId: '976',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  RIACHO_FUNDO_15_966: {
    name: 'Riacho Fundo',
    unitId: '966',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAMAMBAIA_15_967: {
    name: 'SAMAMBAIA ',
    unitId: '967',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAMAMBAIA_SUL_15_969: {
    name: 'Samambaia Sul',
    unitId: '969',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTAMARIA_15_970: {
    name: 'SANTA MARIA',
    unitId: '970',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_SEBASTIAO_15_1276: {
    name: 'São Sebastiao',
    unitId: '1276',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SOBRADINHO_15_959: {
    name: 'Sobradinho',
    unitId: '959',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=959&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  SOBRADINHO_QD08_15_960: {
    name: 'SOBRADINHO - QD08',
    unitId: '960',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=960&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  AMERICANA18_32_1025: {
    name: 'Americana 18',
    unitId: '1025',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1025&campanha=digital&seg=vaci',
      },
    ],
  },
  IRACEMAPOLIS_32_1026: {
    name: 'Iracemapolis',
    unitId: '1026',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LIMEIRAIII_32_1027: {
    name: 'Limeira III',
    unitId: '1027',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LIMEIRAII_32_1028: {
    name: 'Limeira II',
    unitId: '1028',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LIMEIRA1_32_1030: {
    name: 'Limeira 1',
    unitId: '1030',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1030&campanha=hibrido&seg=vaci',
      },
    ],
  },
  PAULISTA_32_1031: {
    name: 'Paulista',
    unitId: '1031',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTA_TEREZINHA_32_1032: {
    name: 'Santa Terezinha',
    unitId: '1032',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTATEREZINHA_32_1032: {
    name: 'SANTA TEREZINHA',
    unitId: '1032',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  RIO_DAS_PEDRAS_32_1034: {
    name: 'Rio das Pedras',
    unitId: '1034',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAOPEDRO_32_1035: {
    name: 'São Pedro',
    unitId: '1035',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TIETE_32_1036: {
    name: 'Tiete',
    unitId: '1036',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  AV_SAOPAULO_32_1037: {
    name: 'Av São Paulo',
    unitId: '1037',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CARLOSBOTELHO_32_1038: {
    name: 'Carlos Botelho',
    unitId: '1038',
    serviceDesk: '6',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  POSTO_CENTRO_32_1039: {
    name: 'Posto Centro',
    unitId: '1039',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JARDIM_EUROPA_32_1040: {
    name: 'Jardim Europa',
    unitId: '1040',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JD_SANTANA_MONUMENTO_32_1041: {
    name: 'Jd Santana Monumento',
    unitId: '1041',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PREVILAB_JD_SANTANA_MONUMENTO_32_1041: {
    name: 'PREVILAB - JD.SANTANA / MONUMENTO',
    unitId: '1041',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  NOIVA_DA_COLINA_32_1042: {
    name: 'Noiva da Colina',
    unitId: '1042',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PREVILAB_NOIVADACOLINA_32_1042: {
    name: 'PREVILAB - NOIVA DA COLINA',
    unitId: '1042',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAPIVARI_32_1043: {
    name: 'Capivari',
    unitId: '1043',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LARANJAL_PAULISTA_32_1044: {
    name: 'Laranjal Paulista',
    unitId: '1044',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MATRIZ_SEDE_32_1045: {
    name: 'Matriz Sede',
    unitId: '1045',
    serviceDesk: '12',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1045&campanha=digital&seg=vaci',
      },
    ],
  },
  UNIDADE_CERQUILHO_32_1046: {
    name: 'Unidade Cerquilho',
    unitId: '1046',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUDOESTE_15_961: {
    name: 'Sudoeste',
    unitId: '961',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=961&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  LAVOISIER_PQSAOLUCAS_2_1048: {
    name: 'LAVOISIER - PQ SAO LUCAS',
    unitId: '1048',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BRONSTEIN_CAXIASBRIGADEIRO_3_1050: {
    name: 'BRONSTEIN - CAXIAS BRIGADEIRO',
    unitId: '1050',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  COMPLEXODASAMERICAS_24_1051: {
    name: 'Complexo das Américas',
    unitId: '1051',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  D829_FS_CAMPINAGRANDE_8_1052: {
    name: 'D829 - FS - CAMPINA GRANDE',
    unitId: '1052',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MOEMA_19_1057: {
    name: 'Moema',
    unitId: '1057',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altamoema-rdi?d=checkin&u=1057',
      },
    ],
  },
  PREVILAB_LIMEIRA_4_32_1061: {
    name: 'PREVILAB - LIMEIRA - 4',
    unitId: '1061',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
  },
  LAVOISIER_METROBUTANTA_2_1062: {
    name: 'Lavoisier - Metro Butanta',
    unitId: '1062',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MEGATIJUCA_RDI_3_1064: {
    name: 'Mega Tijuca - Rdi',
    unitId: '1064',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  POMPEIA_1_1065: {
    name: 'Pompeia',
    unitId: '1065',
    serviceDesk: '7 e 12',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1065&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1065',
      },
    ],
  },
  PANAMBY_19_1066: {
    name: 'Panamby',
    unitId: '1066',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1066&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altapanamby-rdi?d=checkin&u=1066',
      },
    ],
  },
  GILSONCIDRIM_CABOI_37_1107: {
    name: 'GILSON CIDRIM - CABO I',
    unitId: '1107',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_PALMARES_37_1108: {
    name: 'GILSON CIDRIM - PALMARES',
    unitId: '1108',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_IPOJUCA_37_1109: {
    name: 'GILSON CIDRIM - IPOJUCA',
    unitId: '1109',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_CABOII_37_1110: {
    name: 'GILSON CIDRIM - CABO II',
    unitId: '1110',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_RIBEIRAO_37_1111: {
    name: 'GILSON CIDRIM - RIBEIRAO',
    unitId: '1111',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TIMBAUBA_34_1112: {
    name: 'Timbauba',
    unitId: '1112',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_VITORIADESANTOANTAO_37_1113: {
    name: 'GILSON CIDRIM - VITORIA DE SANTO ANTAO',
    unitId: '1113',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_GRAVATA_37_1114: {
    name: 'GILSON CIDRIM - GRAVATA',
    unitId: '1114',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_DERBYII_34_1115: {
    name: 'Cerpe - Derby Ii',
    unitId: '1115',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  DA30_CASACAIADAI_34_1116: {
    name: 'DA30 - CASA CAIADA I',
    unitId: '1116',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  AMERICASSHOPPING_24_1118: {
    name: 'AMERICAS SHOPPING',
    unitId: '1118',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  GILSONCIDRIM_JANGA_37_1119: {
    name: 'GILSON CIDRIM - JANGA',
    unitId: '1119',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_LIMOEIRO_37_1120: {
    name: 'GILSON CIDRIM - LIMOEIRO',
    unitId: '1120',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_SURUBIM_37_1121: {
    name: 'GILSON CIDRIM - SURUBIM',
    unitId: '1121',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_BARRADEJANGADA_37_1122: {
    name: 'GILSON CIDRIM - BARRA DE JANGADA',
    unitId: '1122',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_PRAZERES_37_1123: {
    name: 'GILSON CIDRIM - PRAZERES',
    unitId: '1123',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_SETUBALII_34_1124: {
    name: 'Cerpe - Setubal I I',
    unitId: '1124',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_PIEDADEII_34_1126: {
    name: 'Cerpe - Piedade I I',
    unitId: '1126',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_CASAAMARELA_34_1128: {
    name: 'Cerpe - Casa Amarela',
    unitId: '1128',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_BEBERIBE_37_1129: {
    name: 'GILSON CIDRIM - BEBERIBE',
    unitId: '1129',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_PEIXINHOS_37_1130: {
    name: 'GILSON CIDRIM - PEIXINHOS',
    unitId: '1130',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_IPSEP_34_1131: {
    name: 'Cerpe - Ipsep',
    unitId: '1131',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_IBURA_37_1132: {
    name: 'GILSON CIDRIM - IBURA',
    unitId: '1132',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_JABOATAO_37_1134: {
    name: 'GILSON CIDRIM - JABOATAO',
    unitId: '1134',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_CAVALEIRO_37_1135: {
    name: 'GILSON CIDRIM - CAVALEIRO',
    unitId: '1135',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_BEZERROS_34_1137: {
    name: 'CERPE - BEZERROS',
    unitId: '1137',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_SANTACRUZDOCAPIBARIBE_37_1138: {
    name: 'GILSON CIDRIM - SANTA CRUZ DO CAPIBARIBE',
    unitId: '1138',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_CARUARU_37_1139: {
    name: 'GILSON CIDRIM - CARUARU',
    unitId: '1139',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_ALDEIA_37_1142: {
    name: 'GILSON CIDRIM - ALDEIA',
    unitId: '1142',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_CAMARAGIBE_37_1143: {
    name: 'GILSON CIDRIM - CAMARAGIBE',
    unitId: '1143',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  GILSONCIDRIM_CAXANGA_37_1144: {
    name: 'GILSON CIDRIM - CAXANGA',
    unitId: '1144',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  DA24_JARDIMSAOPAULO_34_1145: {
    name: 'DA24 - JARDIM SÃO PAULO',
    unitId: '1145',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  MARKETPLACE_19_1146: {
    name: 'Market Place',
    unitId: '1146',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1146&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altamarketplace-rdi?d=checkin&u=1146',
      },
    ],
  },
  ALTODEPINHEIROS_19_1147: {
    name: 'Alto de Pinheiros',
    unitId: '1147',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1147&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altapinheiros-rdi?d=checkin&u=1147',
      },
    ],
  },
  BARAODECERROAZUL_10_1148: {
    name: 'Barão de Cerro Azul',
    unitId: '1148',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=1148&campanha=hibrido&seg=vaci',
      },
    ],
  },
  CERPE_MADALENAPRIME_34_1150: {
    name: 'Cerpe - Madalena Prime',
    unitId: '1150',
    serviceDesk: '5',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1150&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  LV_LARGO13_2_1152: {
    name: 'LV - LARGO 13',
    unitId: '1152',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_JOAODEBARROS_34_1154: {
    name: 'Cerpe - Joao de Barros',
    unitId: '1154',
    serviceDesk: '3',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CAMPOBELO_19_1155: {
    name: 'Campo Belo',
    unitId: '1155',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altacampobelo-rdi?d=checkin&u=1155',
      },
    ],
  },
  PARAISO_42_1156: {
    name: 'Paraiso',
    unitId: '1156',
    serviceDesk: '16',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SALOMAO_MOEMA_42_1157: {
    name: 'Salomao- Moema',
    unitId: '1157',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1157',
      },
    ],
  },
  SALOMAO_PANAMBY_42_1158: {
    name: 'Salomao - Panamby',
    unitId: '1158',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1158',
      },
    ],
  },
  IBIRAPUERA_42_1159: {
    name: 'Ibirapuera',
    unitId: '1159',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PORTALDOMORUMBI_42_1160: {
    name: 'Portal do Morumbi',
    unitId: '1160',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1160&campanha=digital&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1160',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=1160',
      },
    ],
  },
  SZ_TATUAPE_42_1161: {
    name: 'SZ - TATUAPÉ',
    unitId: '1161',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1161',
      },
    ],
  },
  SZ_ANGELICA_42_1162: {
    name: 'SZ - ANGÉLICA',
    unitId: '1162',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1162&campanha=hibrido&seg=vaci',
      },
    ],
  },
  SZ_VILAMARIANA_42_1163: {
    name: 'SZ - VILA MARIANA',
    unitId: '1163',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1163',
      },
    ],
  },
  SZ_SANTANA_42_1164: {
    name: 'SZ - SANTANA',
    unitId: '1164',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1164',
      },
    ],
  },
  SZ_ALTODALAPA_42_1165: {
    name: 'SZ - ALTO DA LAPA',
    unitId: '1165',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1165&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1165',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=1165',
      },
    ],
  },
  SZ_OSASCO_42_1166: {
    name: 'SZ - OSASCO',
    unitId: '1166',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Check-in para finalizar seu atendimento',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1166&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/rdi1?d=checkin&u=1166',
      },
      {
        group: 'RDI 2',
        link: 'https://dasa.jotform.com/quest/questionrio-geral-rdi2-sp?d=checkin&u=1166',
      },
    ],
  },
  SALOMAO_JARDINS_42_1167: {
    name: 'Salomao - Jardins',
    unitId: '1167',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: '',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1167&campanha=hibrido&seg=vaci',
      },
    ],
  },
  SUDOESTE_15_1795: {
    name: 'SUDOESTE',
    unitId: '1795',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_BONSUCESSO_GUILHERMEMAXWEL_24_1176: {
    name: 'SF-BONSUCESSO-GUILHERME MAXWEL',
    unitId: '1176',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
  },
  SF_AMERICASSHOPPING_24_1180: {
    name: 'SF-AMERICAS SHOPPING',
    unitId: '1180',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_MULHERLEBLON_24_1188: {
    name: 'SF-MULHER LEBLON',
    unitId: '1188',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CEDILAB_VIDA_101_1189: {
    name: 'Cedilab - Vida',
    unitId: '1189',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_GUAIANASES_2_1190: {
    name: 'LAVOISIER - GUAIANASES',
    unitId: '1190',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BARRADATIJUCA_19_1227: {
    name: 'Barra da Tijuca',
    unitId: '1227',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1227&campanha=hibrido&seg=vaci',
      },
    ],
  },
  BERRINI_1_1243: {
    name: 'Berrini',
    unitId: '1243',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BUTANTA_1_1245: {
    name: 'Butanta',
    unitId: '1245',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ANALIAFRANCO_19_1247: {
    name: 'Analia Franco',
    unitId: '1247',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação.',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1247&campanha=hibrido&seg=vaci',
      },
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altaanalia-rdi?d=checkin&u=1247',
      },
    ],
  },
  LAVOISIER_GUARULHOS_BONSUCESSO_2_1266: {
    name: 'LAVOISIER - GUARULHOS - BONSUCESSO',
    unitId: '1266',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_SHOPPINGFREICANECA_2_1267: {
    name: 'LAVOISIER - SHOPPING FREI CANECA',
    unitId: '1267',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_GUARULHOS_VILAPROGRESSO_2_1268: {
    name: 'LAVOISIER - GUARULHOS - VILA PROGRESSO',
    unitId: '1268',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_GRAJAU_2_1270: {
    endFlowMessage: 'Você será chamado pelo nome em um dos nossos guichês',
    magicTv: false,
    name: 'Lavoisier - Grajau',
    serviceDesk: '',
    tracking: false,
    unitId: '1270',
    uploadExams: true,
  },
  LAVOISIER_M_BOIMIRIM_2_1271: {
    name: 'LAVOISIER - M_BOI MIRIM',
    unitId: '1271',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_METROCONCEICAO_2_1272: {
    name: 'LAVOISIER - METRO CONCEICAO',
    unitId: '1272',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  MAUA_2_1273: {
    name: 'Mauá',
    unitId: '1273',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_SHOPPINGMAUA_2_1273: {
    name: 'LAVOISIER - SHOPPING MAUÁ',
    unitId: '1273',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  LAVOISIER_NOSSASENHORADOSABARA_2_1274: {
    name: 'LAVOISIER - NOSSA SENHORA DO SABARA',
    unitId: '1274',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUDOESTE_CENTRO_CLINICO_15_962: {
    name: 'Sudoeste - Centro Clinico',
    unitId: '962',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TAGUATINGASUL_CSBIV_15_954: {
    name: 'Taguatinga Sul – Csb IV',
    unitId: '954',
    serviceDesk: '4',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    endFlowVaccineMessage:
      'Retire a senha Check-in: Vacina da Gripe e responda o questionário de vacinas',
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas2?d=checkin&u=954&campanha=hibrido&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  REBOUCAS_1_1295: {
    name: 'Reboucas',
    unitId: '1295',
    serviceDesk: '2',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PROMATRE_PAULISTA_19_1313: {
    name: 'Pró Matre / Paulista',
    unitId: '1313',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/questionario/altapaulista-rdi?d=checkin&u=1313',
      },
    ],
  },
  SF_BARRA_AMERICASCORPORATE_24_1318: {
    name: 'SF-BARRA-AMERICAS CORPORATE',
    unitId: '1318',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TAGUATINGASUL_PISTAOSUL_15_955: {
    name: 'Taguatinga Sul - Pistão Sul',
    unitId: '955',
    serviceDesk: '1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TAGUATINGASUL_PISTAOSUL_15_1794: {
    name: 'Taguatinga Sul/Pistão Sul ',
    unitId: '1794',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  CENTRO_24_1336: {
    name: 'Centro',
    unitId: '1336',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  ICARAI_24_1337: {
    name: 'Icaraí',
    unitId: '1337',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  PIRATININGA_24_1338: {
    name: 'Piratininga',
    unitId: '1338',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  BOTAFOGO_24_1341: {
    name: 'Botafogo',
    unitId: '1341',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  RECREIO_24_1343: {
    name: 'Recreio',
    unitId: '1343',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  SANTACRUZ_24_1344: {
    name: 'Santa Cruz',
    unitId: '1344',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  CURICICA_3_1355: {
    name: 'CURICICA',
    unitId: '1355',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
  },
  DRIVECERPEPRIME_34_1594: {
    name: 'Drive Cerpe Prime',
    unitId: '1594',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_DRIVEPIEDADEII_34_1634: {
    name: 'Cerpe - Drive Piedade Ii',
    unitId: '1634',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_DRIVECASAFORTE_34_1641: {
    name: 'Cerpe - Drive Casa Forte',
    unitId: '1641',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  GARIBALDI_40_1735: {
    name: 'Garibaldi',
    unitId: '1735',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1735&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ITAPUA_40_1739: {
    name: 'Itapuã',
    unitId: '1739',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  BROTAS_40_1740: {
    name: 'Brotas',
    unitId: '1740',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  SHOPPINGESTRADADOCOCO_40_1742: {
    name: 'Shopping Estrada do Coco',
    unitId: '1742',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    uploadExams: true,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=1742&campanha=digital&seg=vaci',
      },
    ],
  },
  BARRA_40_1744: {
    name: 'Barra',
    unitId: '1744',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  VILASDOATLANTICO2_40_1747: {
    name: 'Vilas do Atlântico 2',
    unitId: '1747',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CAMINHODASARVORES_40_1748: {
    name: 'Caminho das Arvores',
    unitId: '1748',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  STELLAMARIS_40_1749: {
    name: 'Stella Maris',
    unitId: '1749',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CAMPOGRANDE_40_1750: {
    name: 'Campo Grande',
    unitId: '1750',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  RIOVERMELHO_40_1751: {
    name: 'Rio Vermelho',
    unitId: '1751',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  TANCREDONEVES_LIZ_40_1756: {
    name: 'Tancredo Neves - LIZ',
    unitId: '1756',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  PATAMARES_40_1757: {
    name: 'Patamares',
    unitId: '1757',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CANELA_40_1760: {
    name: 'Canela',
    unitId: '1760',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Check-in realizado. Siga as orientações abaixo no dia do seu atendimento ',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_DRIVEJOAODEBARROS_34_1761: {
    name: 'Cerpe - Drive Joao de Barros',
    unitId: '1761',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  VALPARAISO_15_956: {
    name: 'VALPARAÍSO',
    unitId: '956',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  VICENTE_PIRESII_15_958: {
    name: 'Vicente Pires II',
    unitId: '958',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  DRIVETHRU_PARQUEIBIRAPUERA_1_1796: {
    name: 'Drive Thru-parque Ibirapuera',
    unitId: '1796',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  ALPHAVILLE_40_2316: {
    name: 'Alphaville ',
    unitId: '2316',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CAMINHODEAREIA_40_2317: {
    name: 'Caminho de Areia',
    unitId: '2317',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CANELA_40_2318: {
    name: 'Canela',
    unitId: '2318',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=2318&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  COSTAAZUL_40_2319: {
    name: 'Costa Azul',
    unitId: '2319',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  IMBUI_40_2320: {
    name: 'Imbui',
    unitId: '2320',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    collaboratorVaccineCampaign: true,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=2320&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ITAIGARA_40_2322: {
    name: 'Itaigara',
    unitId: '2322',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    endFlowVaccineMessage:
      'Responda o questionário de vacinas e aguarde seu nome ser chamado na fila de vacinação',
    magicTv: false,
    hasCreditCardPayment: true,
    hasVaccineFlow: true,
    survey: [
      {
        group: 'Vacinas',
        link: 'https://dasa.jotform.com/questionario/vacinas?d=checkin&u=2322&campanha=digital&seg=vaci',
      },
    ],
    uploadExams: true,
  },
  ONDINA_40_2324: {
    name: 'Ondina',
    unitId: '2324',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  PITUBA_40_2326: {
    name: 'Pituba',
    unitId: '2326',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  SAOMARCOS_40_2327: {
    name: 'São Marcos',
    unitId: '2327',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_IGARASSUII_34_1117: {
    name: 'Cerpe - Igarassu I I',
    unitId: '1117',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CERPE_GOIANA_34_1140: {
    name: 'Cerpe - Goiana',
    unitId: '1140',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha Preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SF_RECREIO_24_276: {
    name: 'SF - Recreio',
    unitId: '276',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente para validação do seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LAVOISIER_RIOPEQUENO_2_1269: {
    name: 'Rio Pequeno',
    unitId: '1269',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  RECREIO2_PEDRADEITAUNA_24_1340: {
    name: 'Recreio 2 - Pedra de Itauna',
    unitId: '1340',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente para validação do seu atendimento',
    magicTv: false,
  },
  LARANJEIRAS_24_1778: {
    name: 'Laranjeiras',
    unitId: '1778',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente para validação do seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JARDIMAMERICA_14_624: {
    name: 'Jardim América',
    unitId: '624',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  CEILANDIAV_CETTRO_PREVINE_15_2555: {
    name: 'Ceilandia V - Cettro Previne',
    unitId: '2555',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
  },
  ITAIMBIBI_19_1312: {
    name: 'Itaim Bibi',
    unitId: '1312',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
    survey: [
      {
        group: 'RDI',
        link: 'https://dasa.jotform.com/quest/alta-itaim-rdi?d=checkin&u=1312',
      },
    ],
  },
  SF_NITEROI_PIRATININGA_24_239: {
    name: 'Sf - Niteroi - Piratininga',
    unitId: '239',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente para validação do seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ALPHAVILLE_19_1310: {
    name: 'Alphaville',
    unitId: '1310',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  OESTE_AQUARIUS_59_1248: {
    name: 'Oeste - Aquarius',
    unitId: '1248',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUL_II_59_1254: {
    name: 'Sul II',
    unitId: '1254',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LESTE_I_59_1255: {
    name: 'Leste I',
    unitId: '1255',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  NORTE_59_1256: {
    name: 'Norte',
    unitId: '1256',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTRO_II_59_1258: {
    name: 'Centro II',
    unitId: '1258',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  JACAREI_59_1259: {
    name: 'Jacarei',
    unitId: '1259',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LESTE_II_59_1260: {
    name: 'Leste II',
    unitId: '1260',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTRO_I_59_1261: {
    name: 'Centro I',
    unitId: '1261',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SUL_I_59_1257: {
    name: 'Sul I',
    unitId: '1257',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire a senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BARRA_PENINSULA_24_1153: {
    name: 'Barra Península',
    unitId: '1153',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  COPACABANA_SIQUEIRACAMPOS_24_262: {
    name: 'Copacabana - Siqueira Campos',
    unitId: '262',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BARRA_AVENTURA_CENTER_24_248: {
    name: 'Barra - Aventura Center',
    unitId: '248',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BOTAFOGO_CONDE_IRAJA_24_253: {
    name: 'Botafogo - Conde De Irajá',
    unitId: '253',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  SANTA_CRUZ_24_277: {
    name: 'Santa Cruz',
    unitId: '277',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  VILA_ISABEL_II_24_284: {
    name: 'Vila Isabel II',
    unitId: '284',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BANGU_24_243: {
    name: 'Bangu',
    unitId: '243',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  BARRA_DA_TIJUCA_24_249: {
    name: 'Barra Da Tijuca',
    unitId: '249',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  CAROLINA_MEIER_24_1055: {
    name: 'Carolina Méier',
    unitId: '1055',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTRO_PRESIDENTE_VARGAS_24_2938: {
    name: 'Centro Presidente Vargas',
    unitId: '2938',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CENTRO_SAO_JOSE_24_259: {
    name: 'Centro - São José',
    unitId: '259',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    magicTv: false,
    uploadExams: true,
  },
  NITEROI_ICARAI_24_238: {
    name: 'Niterói - Icaraí',
    unitId: '238',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  FELICITTA_SHOPPING_15_950: {
    name: 'Felicitta Shopping',
    unitId: '950',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  TAGUATINGAI_15_963: {
    name: 'Taguatinga I',
    unitId: '963',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  PATIO_CAPITAL_15_974: {
    name: 'Patio Capital',
    unitId: '974',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  RECANTO_DAS_EMAS_15_965: {
    name: 'Recanto das Emas',
    unitId: '965',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SAMAMBAIA_RENASCER_15_968: {
    name: 'Samambaia Renascer',
    unitId: '968',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SAMAMBAIAIV_15_1175: {
    name: 'Samambaia IV',
    unitId: '1175',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CENTRO_CLINICO_LUCIO_COSTA_15_1324: {
    name: 'Centro Clinico Lucio Costa',
    unitId: '1324',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CEILANDIAIV_15_1291: {
    name: 'Ceilandia IV',
    unitId: '1291',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  JK_SHOPPING_15_1280: {
    name: 'JK Shopping',
    unitId: '1280',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  MATINHOS_8_810: {
    name: 'Matinhos',
    unitId: '810',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  GUARATUBA_8_1056: {
    name: 'Guaratuba',
    unitId: '1056',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  IMMEF_8_2950: {
    name: 'IMMEF',
    unitId: '2950',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  MADUREIRA_24_269: {
    name: 'Madureira',
    unitId: '269',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  BANGU_24_244: {
    name: 'Shopping Bangu',
    unitId: '244',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  PECHINCHA_24_266: {
    name: 'Pechincha',
    unitId: '266',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  TIJUCA_URUGUAI_24_1179: {
    name: 'Tijuca - Uruguai',
    unitId: '1179',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  NITEROI_CENTRO_24_237: {
    name: 'Niteroi - Centro',
    unitId: '237',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar o seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  REALENGO_24_275: {
    name: 'Realengo',
    unitId: '275',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  TAQUARA_24_267: {
    name: 'Taquara',
    unitId: '267',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ALCANTARA_24_286: {
    name: 'Alcântara',
    unitId: '286',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ITAIM_PAULISTA_II_2_881: {
    name: 'Itaim Paulista II',
    unitId: '881',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  VILA_GALVAO_2_872: {
    name: 'Vila Galvão',
    unitId: '872',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  COTIA_2_859: {
    name: 'Cotia',
    unitId: '859',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  LEBLON_4_445: {
    name: 'Leblon',
    unitId: '445',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ILHA_4_443: {
    name: 'Ilha',
    unitId: '443',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CABULA_40_2894: {
    name: 'Cabula',
    unitId: '2894',
    serviceDesk: '',
    tracking: true,
    endFlowMessage: 'Você será chamado pelo nome no painel de senhas',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  BRAZ_LEME_19_2638: {
    name: 'Braz Leme',
    unitId: '2638',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasCreditCardPayment: true,
  },
  DEL_CASTILHO_3_404: {
    name: 'Del Castilho',
    unitId: '404',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SHOPPING45_3_429: {
    name: 'Shopping 45',
    unitId: '429',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SAO_JOAO_DO_MERITI_3_1307: {
    name: 'São João do Meriti',
    unitId: '1307',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CONEGO_AFONSO_2_899: {
    name: 'Osasco Cônego Afonso',
    unitId: '899',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CAPAO_REDONDO_2_851: {
    name: 'Capão Redondo',
    unitId: '851',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ANA_ROSA_2_893: {
    name: 'Metrô Ana Rosa',
    unitId: '893',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  LARGO_MACHADO_CATETE_24_268: {
    name: 'Largo Machado - Catete',
    unitId: '268',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: ' Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  FREGUESIA_24_265: {
    name: 'Freguesia',
    unitId: '265',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  TERESOPOLIS_3_432: {
    name: 'Teresópolis',
    unitId: '432',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ICARAI_NITEROI_3_387: {
    name: 'Icaraí',
    unitId: '387',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha do Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  VITORIA_DE_SANTO_ANTAO_34_645: {
    name: 'Vitória de Santo Antão',
    unitId: '645',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SHOPPING_ELDORADO_1_702: {
    name: 'Shopping Eldorado',
    unitId: '702',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha preferencial para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  VILA_NOVA_CACHOERINHA_2_938: {
    name: 'Vila Nova Cachoerinha',
    unitId: '938',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  PERUS_2_902: {
    name: 'Perus',
    unitId: '902',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  LAPA_CATAO_2_887: {
    name: 'Lapa Catão',
    unitId: '887',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  VILA_MASCOTE_2_941: {
    name: 'Vila Mascote',
    unitId: '941',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CURSINO_2_860: {
    name: 'Cursino',
    unitId: '860',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  LIMAO_CELESTINO_BOURROUL_2_1060: {
    name: 'Limão Celestino Bourroul',
    unitId: '1060',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  SHOPPING_METRO_ITAQUERA_2_857: {
    name: 'Shopping Metro Itaquera',
    unitId: '857',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  LEME_24_1182: {
    name: 'Leme',
    unitId: '1182',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CAMPO_GRANDE_I_24_256: {
    name: 'Campo Grande I',
    unitId: '256',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  PENHA_24_274: {
    name: 'Penha',
    unitId: '274',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  BARRA_JARDIM_OCEANICO_24_245: {
    name: 'Barra Jardim Oceanico',
    unitId: '245',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez Check-in',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  CACHAMBI_24_255: {
    name: 'Cachambi',
    unitId: '255',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  ITAPEVI_2_882: {
    name: 'Itapevi',
    unitId: '882',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Agendamento Online para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
    hasVaccineFlow: false,
  },
  PETROPOLIS_28_947: {
    name: 'Petropolis',
    unitId: '947',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  ICARAI512_17_114: {
    name: 'Icarai 512',
    unitId: '114',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  ICARAI509_17_112: {
    name: 'Icarai 509',
    unitId: '112',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  ICARAI511_17_113: {
    name: 'Icarai 511',
    unitId: '113',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  CONSMED_17_1487: {
    name: 'Consmed',
    unitId: '1487',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  ARUJA_CENTRO_102_1665: {
    name: 'Aruja Centro',
    unitId: '1665',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  POA_102_1668: {
    name: 'Poa',
    unitId: '1668',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAQUA_VILA_VIRGINIA_102_1672: {
    name: 'Itagua Vila Virginia',
    unitId: '1672',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SUZANO_102_1669: {
    name: 'SUZANO',
    unitId: '1669',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  GUARULHOS_MAE_DOS_HOMENS_102_1689: {
    name: 'Guarulhos Mae dos homens',
    unitId: '1689',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SANTA_ISABEL_102_1678: {
    name: 'Santa Isabel',
    unitId: '1678',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento.',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAQUA_CENTRO_102_1670: {
    name: 'Itaqua centro',
    unitId: '1670',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MOGI_VILA_OLIVEIRA_102_1680: {
    name: 'Mogi Vila Oliveira',
    unitId: '1680',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento.',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAQUA_GARDEN_SHOPPING_102_1673: {
    name: 'Itaqua Garden Shopping',
    unitId: '1673',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MOGI_CENTRO_102_1679: {
    name: 'Mogi centro',
    unitId: '1679',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MAX_COLIN_107_1952: {
    name: 'Max colin',
    unitId: '1952',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  POPULAR_107_1942: {
    name: 'Popular',
    unitId: '1942',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  IRIRIU_107_1953: {
    name: 'Iririu',
    unitId: '1953',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAPOA_107_1944: {
    name: 'Itapoa',
    unitId: '1944',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAO_FRANCISCO_DO_SUL_107_1959: {
    name: 'Sao Francisco do Sul',
    unitId: '1959',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  GARUVA_107_1949: {
    name: 'Guaruva',
    unitId: '1949',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  GHANEMZINHO_107_1941: {
    name: 'Ghanemzinho',
    unitId: '1941',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BALNEARIO_CAMBORIU_107_1948: {
    name: 'Balneario Camboriu',
    unitId: '1948',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BOA_VISTA_107_1958: {
    name: 'Boa Vista',
    unitId: '1958',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  VILA_NOVA_107_1954: {
    name: 'Vila Nova',
    unitId: '1954',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  AVENTUREIRO_107_1950: {
    name: 'Aventureiro',
    unitId: '1950',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ANITA_GARIBALDI_107_1960: {
    name: 'Anita Garibaldi',
    unitId: '1960',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PIRABEIRABA_107_1946: {
    name: 'Pirabeiraba',
    unitId: '1946',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SHOPPING_MUELLER_107_1943: {
    name: 'Shopping Mueller',
    unitId: '1943',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  MULHER_107_1940: {
    name: 'Ghanem Mulher',
    unitId: '1940',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  FLORESTA_107_1957: {
    name: 'Floresta',
    unitId: '1957',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAO_MARCOS_107_1956: {
    name: 'Sao Marcos',
    unitId: '1956',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  COSTA_E_SILVA_107_1951: {
    name: 'Costa e Silva',
    unitId: '1951',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAUM_107_1961: {
    name: 'Itaum',
    unitId: '1961',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITU_MATRIZ_105_1767: {
    name: 'Itu Matriz',
    unitId: '1767',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SALTO_105_1769: {
    name: 'Salto',
    unitId: '1769',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PORTO_FELIZ_105_1770: {
    name: 'Porto feliz',
    unitId: '1770',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  IMAGEM_105_1771: {
    name: 'Imagem',
    unitId: '1771',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MATRIZ_HARMONY_11_836: {
    name: 'Harmony',
    unitId: '836',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ALDEOTA_11_827: {
    name: 'Aldeota',
    unitId: '827',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MONTESE_11_839: {
    name: 'Montese',
    unitId: '839',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MEIRELES_11_837: {
    name: 'Meireles',
    unitId: '837',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  FATIMA_11_831: {
    name: 'Fatima',
    unitId: '831',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BARRA_DO_CEARA_11_828: {
    name: 'Barra do Ceará',
    unitId: '828',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PARANGABA_11_841: {
    name: 'Parangaba',
    unitId: '841',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_FORTALEZA_11_830: {
    name: 'Centro Fortaleza',
    unitId: '830',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BEZERRA_DE_MENEZES_11_829: {
    name: 'Bezerra de Menezes',
    unitId: '829',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MESSEJANA_11_838: {
    name: 'Messejana',
    unitId: '838',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  OLIVEIRA_PAIVA_11_840: {
    name: 'Oliveira Paiva',
    unitId: '840',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ICARAI_29_946: {
    name: 'Icarai',
    unitId: '946',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  MADUREIRA_29_945: {
    name: 'Madureira',
    unitId: '945',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  IPANEMA_29_944: {
    name: 'Ipanema',
    unitId: '944',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_29_943: {
    name: 'Centro',
    unitId: '943',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  OSWALDINHO_39_1298: {
    name: 'Oswaldinho',
    unitId: '1298',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_39_1319: {
    name: 'Centro',
    unitId: '1319',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MATRIZ_39_1296: {
    name: 'Matriz',
    unitId: '1296',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ZONA_LESTE_39_1297: {
    name: 'Zona Leste',
    unitId: '1297',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  AQUARIUS_39_1301: {
    name: 'Aquarius',
    unitId: '1301',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BOSQUE_39_1299: {
    name: 'Bosque',
    unitId: '1299',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MATRIZ_103_1656: {
    name: 'Matriz',
    unitId: '1656',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PEDREGULHO_41_1645: {
    name: 'Pedregulho',
    unitId: '1645',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CRUZEIRO_41_1649: {
    name: 'Cruzeiro',
    unitId: '1649',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  APARECIDA_41_1646: {
    name: 'Aparecida',
    unitId: '1646',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CHACARA_SELLES_SANTA_ROSA_41_1644: {
    name: 'Santa Rosa',
    unitId: '1644',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  LORENA_CENTRO_41_1652: {
    name: 'Lorena Centro',
    unitId: '1652',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  LORENA_LULU_MEYER_41_1648: {
    name: 'Lorena Lulu Meyer',
    unitId: '1648',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CACHOEIRA_PAULISTA_41_1647: {
    name: 'Cachoeira Paulista',
    unitId: '1647',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  GRUPO_ATENDE_41_1650: {
    name: 'Grupo atende',
    unitId: '1650',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MATRIZ_41_1643: {
    name: 'Matriz',
    unitId: '1643',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_II_SUS_59_1853: {
    name: 'Centro II SUS',
    unitId: '1853',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  NORTE_SUS_59_1849: {
    name: 'Norte SUS',
    unitId: '1849',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  LESTE_I_SUS_59_1847: {
    name: 'Leste I SUS',
    unitId: '1847',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SUL_I_SUS_59_1851: {
    name: 'Sul I SUS',
    unitId: '1851',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  LESTE_II_SUS_59_1855: {
    name: 'Leste II SUS',
    unitId: '1855',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  COLETA_CONSULT_41_1653: {
    name: 'Coleta consultórios',
    unitId: '1653',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  COXIPO_89_3000: {
    name: 'Coxipo',
    unitId: '3000',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  CRISTO_REI_89_3001: {
    name: 'Cristo Rei',
    unitId: '3001',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  FILINTO_MILLER_89_3018: {
    name: 'Filinto Miller',
    unitId: '3018',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  JARDIM_CUIABA_89_3003: {
    name: 'Jardim Cuiaba',
    unitId: '3003',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  BOSQUE_DA_SAUDE_89_3006: {
    name: 'Bosque da saude',
    unitId: '3006',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  BAU_89_3005: {
    name: 'Bau',
    unitId: '3005',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  BARAO_DE_MLEGAÇO_89_3004: {
    name: 'Barão de melgaço',
    unitId: '3004',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  CPA2_89_2999: {
    name: 'CPA2',
    unitId: '2999',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  PRONTO_ATENDIMENTO_89_3021: {
    name: 'Pronto atendimento',
    unitId: '3021',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SAO_JUDAS_89_3002: {
    name: 'Sao Judas',
    unitId: '3002',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  LEBLON_25_3053: {
    name: 'Leblon',
    unitId: '3053',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  MDX_25_3054: {
    name: 'Mdx',
    unitId: '3054',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  CORPORATE_25_1317: {
    name: 'Corporate',
    unitId: '1317',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  TIJUCA_25_3056: {
    name: 'Tijuca',
    unitId: '3056',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  NOVA_AMERICA_25_3055: {
    name: 'Nova America',
    unitId: '3055',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  COPACABANA_25_1186: {
    name: 'Copacabana',
    unitId: '1186',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  BANGU_25_3057: {
    name: 'Bangu',
    unitId: '3057',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  RECREIO_25_1183: {
    name: 'Recreio',
    unitId: '1183',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  LEBLON_MULHER_25_1185: {
    name: 'Leblon Mulher',
    unitId: '1185',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  BARRA_SHOPPING_25_3058: {
    name: 'Barra Shopping',
    unitId: '3058',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  /* Unidades que ainda nao tem o processo 3 cadastrad0 16/02/23 */
  SAO_LUCAS_102_1699: {
    name: 'Centro Medico Sao Lucas',
    unitId: '1699',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAO_LUCAS_URGENCIA_102_1693: {
    name: 'Sao Lucas Urgencia',
    unitId: '1693',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAO_PAULO_102_1700: {
    name: 'Sao Paulo',
    unitId: '1700',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ATENDE_PREFEITURAS_102_1697: {
    name: 'Grupo Atende Prefeituras',
    unitId: '1697',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  GUARULHOS_CENTRO_102_1674: {
    name: 'Guarulhos Centro',
    unitId: '1674',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ATENDE_CLINICAS_102_1696: {
    name: 'Grupo Atende Clinicas',
    unitId: '1696',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BIO_CENTRO_102_1681: {
    name: 'Bio Centro',
    unitId: '1681',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PRO_RIM_107_2263: {
    name: 'Pro Rim',
    unitId: '2263',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ARCELORMITTAL_107_2988: {
    name: 'Arcelormittal',
    unitId: '2988',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PRO_RIM_FUNCIONARIOS_107_2972: {
    name: 'Pro rim Funcionarios',
    unitId: '2972',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  COLETA_CONSULTORIOS_105_1774: {
    name: 'Coleta consultorios',
    unitId: '1774',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  UBS_RESOLVE_SUS_59_1636: {
    name: 'UBS Resolve SUS',
    unitId: '1636',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  NEFROMED_59_1263: {
    name: 'Nefromed',
    unitId: '1263',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_I_SUS_59_1857: {
    name: 'Centro I SUS',
    unitId: '1857',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CCP_59_2545: {
    name: 'Coleta CCP',
    unitId: '2545',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CTA_59_1368: {
    name: 'Centro tecnico aeroespacial',
    unitId: '1368',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SUL_I_SUS_59_1845: {
    name: 'Sul I SUS',
    unitId: '1845',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_Iii_59_2469: {
    name: 'Centro Iii',
    unitId: '2469',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PINDAMONHAGABA_III_41_1651: {
    name: 'Pindamonhagaba',
    unitId: '1651',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BARRA_DOWNTOWN_3_390: {
    name: 'Barra Downtown',
    unitId: '390',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ARUJA_CONDOMINIOS_102_1666: {
    name: 'Aruja Condominios',
    unitId: '1666',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CATETE_3_399: {
    name: 'Catete',
    unitId: '399',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CURICICA_3_508: {
    name: 'Curicica',
    unitId: '508',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ILHA_DO_GOVERNADOR_3_407: {
    name: 'Ilha do Governador',
    unitId: '407',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ILHA_DO_GOVERNADOR_II_AC_3_1265: {
    name: 'Ilha do Governador Ii AC',
    unitId: '1265',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MEGA_TIJUCA_AC_3_1054: {
    name: 'Mega Tijuca AC',
    unitId: '1054',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  NOVA_IGUACU_3_388: {
    name: 'Nova Iguaçu',
    unitId: '388',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  RECREIO_3_424: {
    name: 'Recreio',
    unitId: '424',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  JULIO_ADNET_15_1781: {
    name: 'Julio Adnet',
    unitId: '1781',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CARAPICUIBA_I_SERAFICO_2_853: {
    name: 'Carapicuiba - I Serafico',
    unitId: '853',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PIRITUBA_2_903: {
    name: 'Pirituba',
    unitId: '903',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BARRA_RIO2_24_247: {
    name: 'Barra Rio 2',
    unitId: '247',
    tracking: false,
    endFlowMessage: 'Informe ao atendente que você fez check-in',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ITAGUAI_24_235: {
    name: 'Itaguai',
    unitId: '235',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  TIJUCA_PINTO_FIGUEIREDO_24_282: {
    name: 'Tijuca Pinto de Figueiredo',
    unitId: '282',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CAMPO_GRANDEII_24_257: {
    name: 'Campo Grande II',
    unitId: '257',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ILHA_GOVERNADOR_24_263: {
    name: 'Ilha Governador',
    unitId: '263',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CAIEIRAS_2_849: {
    name: 'Caieiras',
    unitId: '849',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  TIJUCA_24_280: {
    name: 'Tijuca Haddock Lobo',
    unitId: '280',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ESTRADA_DE_ITAPECERICA_2_864: {
    name: 'Estrada de Itapecerica',
    unitId: '864',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  VILA_VALQUEIRE_24_285: {
    name: 'Vila Valqueire',
    unitId: '285',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  FREGUESIAII_3_1067: {
    name: 'Freguesia Ii',
    unitId: '1067',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  RIO_COMPRIDO_3_507: {
    name: 'Rio Comprido',
    unitId: '507',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SANTA_CRUZ_3_2868: {
    name: 'Santa Cruz',
    unitId: '2868',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  IRAJA_3_410: {
    name: 'Iraja',
    unitId: '410',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  IPANEMA_VISCONDE_DE_PIRAJA_24_264: {
    name: 'Ipanema Visconde de Piraja',
    unitId: '264',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MEIER_MANUELA_BARBOSA_24_2515: {
    name: 'Meier Manuela Barbosa',
    unitId: '2515',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  RECREIO_BARRA_BONITA_24_1246: {
    name: 'Recreio Barra Bonita',
    unitId: '1246',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BOTAFOGO_SOROCABA_24_254: {
    name: 'Botafogo Sorocaba',
    unitId: '254',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  COPACABANA_NOSSA_SENHORA_24_1181: {
    name: 'Copacabana Nossa Senhora 583',
    unitId: '1181',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  IPANEMA_19_2520: {
    name: 'Ipanema',
    unitId: '2520',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CARAPICUIBA_2_852: {
    name: 'Carapicuiba',
    unitId: '852',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  ASA_SUL_TORREII_15_2435: {
    name: 'Asa Sul Torre II',
    unitId: '2435',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  VILA_ISABEL_24_283: {
    name: 'Vila Isabel',
    unitId: '283',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  AGUAS_CLARASIII_15_2388: {
    name: 'Aguas Claras III',
    unitId: '2388',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BORIS_PAULISTA_34_2951: {
    name: 'Boris Paulista',
    unitId: '2951',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CLIN_CASSI_SIG_15_2871: {
    name: 'Clin Cassi Sig',
    unitId: '2871',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BORIS_DERBY_34_2953: {
    name: 'Boris Derby',
    unitId: '2953',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  AMMA_15_2903: {
    name: 'Amma',
    unitId: '2903',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BORIS_BOA_VIAGEM_34_2906: {
    name: 'Boris Boa Viagem',
    unitId: '2906',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  PEDREGAL_15_1293: {
    name: 'Pedregal',
    unitId: '1293',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BORIS_CABO_34_2940: {
    name: 'Boris Cabo',
    unitId: '2940',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CENTRO_CLINICO_TORREI_15_1780: {
    name: 'Centro Clinico Torre I',
    unitId: '1780',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  TAGUACENTER_15_1275: {
    name: 'Taguacenter',
    unitId: '1275',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  VIA_BRASIL_15_2905: {
    name: 'Via Brasil',
    unitId: '2905',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  TERRACO_SHOPPING_15_2432: {
    name: 'Terraco Shopping',
    unitId: '2432',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  POSTO_HAC_AMBULATORIO_15_2902: {
    name: 'Posto Hac - Ambulatorio',
    unitId: '2902',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SANTA_MARIAII_15_2557: {
    name: 'Santa Maria II',
    unitId: '2557',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  EDIF_SABIN_15_2904: {
    name: 'Edif. Sabin',
    unitId: '2904',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  LINEA_VITTA_15_1782: {
    name: 'Linea Vitta',
    unitId: '1782',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  BORIS_PIEDADE_34_2952: {
    name: 'Boris Piedade',
    unitId: '2952',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_SAOCAMILO_COLETACONSUL_126_3095: {
    name: 'SAC-São Camilo Coleta Consul',
    unitId: '3095',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_CLINIPREV_126_2992: {
    name: 'SAC - Cliniprev',
    unitId: '2992',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_UNIDADE_MULHER_126_2993: {
    name: 'SAC-Unidade Mulher',
    unitId: '2993',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MATRIZ_126_3024: {
    name: 'Matriz',
    unitId: '3024',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_ALVORADA_126_2116: {
    name: 'SC-Alvorada',
    unitId: '2116',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_COLETA_DOMICILIAR_126_2120: {
    name: 'SC-Coleta Domiciliar',
    unitId: '2120',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_INFANTIL_126_2124: {
    name: 'SC-Infantil',
    unitId: '2124',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_LAGUNA_126_2131: {
    name: 'SC-Laguna',
    unitId: '2131',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_MANDACARU_126_2125: {
    name: 'SC-Mandacaru',
    unitId: '2125',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_MATRIZ_127_2126: {
    name: 'SC-Matriz',
    unitId: '2126',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SC_MELHOR_IDADE_126_2127: {
    name: 'SC-Melhor Idade',
    unitId: '2127',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_PALMEIRAS_126_2128: {
    name: 'SC-Palmeiras',
    unitId: '2128',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_RIO_BRANCO_126_2130: {
    name: 'SC-Rio_Branco',
    unitId: '2130',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_TEIXEIRA_MENDES_126_2132: {
    name: 'SC-Teixeira Mendes',
    unitId: '2132',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_CLINIPREV_127_2118: {
    name: 'SC-Cliniprev',
    unitId: '2118',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SC_COI_127_2119: {
    name: 'SC-Coi',
    unitId: '2119',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SC_MULHER_127_2390: {
    name: 'SC-Mulher',
    unitId: '2390',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  ALVORADA_123_2956: {
    name: 'Alvorada',
    unitId: '2956',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  CLINIPREV_123_2957: {
    name: 'Cliniprev',
    unitId: '2957',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  G051_SAOCAMILO_MATRIZ_123_2963: {
    name: 'G051-São Camilo Matriz',
    unitId: '2963',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  MULHER_123_2965: {
    name: 'Mulher',
    unitId: '2965',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  RIO_BRANCO_123_2967: {
    name: 'Rio Branco',
    unitId: '2967',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  TEIXEIRA_MENDES_123_2968: {
    name: 'Teixeira Mendes',
    unitId: '2968',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SC_ANATOMIA_123_2117: {
    name: 'SC-Anatomia',
    unitId: '2117',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  VC_JACAREI_59_2472: {
    name: 'VC-Jacareí',
    unitId: '2472',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: true,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_AUTODROMO_126_3375: {
    name: 'Sac - Autodromo',
    unitId: '3375',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_GLEBA_PALHANO_126_3376: {
    name: 'Sac - Gleba Palhano',
    unitId: '3376',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  SAC_HIGIENOPOLIS_126_3377: {
    name: 'Sac - Higienopolis',
    unitId: '3377',
    tracking: false,
    endFlowMessage: 'Retire uma senha de check-in para finalizar seu atendimento',
    uploadExams: false,
    magicTv: false,
    serviceDesk: '',
  },
  GAMA_MC_DONALDS_15_2987: {
    name: 'Gama MC Donald s',
    unitId: '2987',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  VITRIUM_15_2558: {
    name: 'Vitrium',
    unitId: '2558',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  CEILANDIA_NORTE_15_2973: {
    name: 'Ceilandia Norte',
    unitId: '2973',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BR_BARRARIO2_FQ_3_3245: {
    name: 'BR-BARRA RIO 2 FQ',
    unitId: '3245',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  PARANAGUA_8_2430: {
    name: 'Paranagua',
    unitId: '2430',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  NOVAIGUACU_DR_BARROSJR_24_241: {
    name: 'Nova Iguacu - DR. Barros jr',
    unitId: '241',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  TIJUCA_PRACA_SAENSPENAI_24_281: {
    name: 'Tijuca - Praca Saens Pena I',
    unitId: '281',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_CARIJOS_3480: {
    name: 'Carijós',
    unitId: '3480',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_FRANSCISCO_SALES_3484: {
    name: 'Francisco Sales',
    unitId: '3484',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BURITIS_3478: {
    name: 'Buritis',
    unitId: '3478',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_NOVA_LIMA_3487: {
    name: 'Nova Lima',
    unitId: '3487',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_PEDRO_II_3489: {
    name: 'Pedro II',
    unitId: '3489',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SANTA_TEREZA_3497: {
    name: 'Santa Tereza',
    unitId: '3497',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BERNARDO_MONTEIRO_3475: {
    name: 'Bernardo Monteiro',
    unitId: '3475',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_CIDADE_NOVA_3481: {
    name: 'Cidade Nova',
    unitId: '3481',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SAO_BENEDITO_3492: {
    name: 'Sao Benedito',
    unitId: '3492',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_CAIÇARA_3479: {
    name: 'Caiçara',
    unitId: '3479',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SAVASSI_3471: {
    name: 'Savassi',
    unitId: '3471',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_GRAJAU_3485: {
    name: 'Grajau',
    unitId: '3485',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_JUSTINOPOLIS_3486: {
    name: 'Justinopolis',
    unitId: '3486',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_PLANALTO_3490: {
    name: 'Planalto',
    unitId: '3490',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BARBACENA_3473: {
    name: 'Barbacena',
    unitId: '3473',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_TUPIS_3493: {
    name: 'Tupis',
    unitId: '3493',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SAGRADA_FAMILIA_3496: {
    name: 'Sagrada Familia',
    unitId: '3496',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SANTA_EFIGENIA_3495: {
    name: 'Santa Efigenia',
    unitId: '3495',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_OURO_PRETO_3488: {
    name: 'Ouro Preto',
    unitId: '3488',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BARREIRO_II_3474: {
    name: 'Barreiro II',
    unitId: '3474',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BETIM_3476: {
    name: 'Betim',
    unitId: '3476',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_CONTAGEM_3483: {
    name: 'Contagem',
    unitId: '3483',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_BRUMADINHO_3477: {
    name: 'Brumadinho',
    unitId: '3477',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUSTOSA_SARZEDO_3494: {
    name: 'Sarzedo',
    unitId: '3494',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUNAV_MATRIZ_3440: {
    name: 'Matriz',
    unitId: '3440',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  LUNAV_SAO_JOSE_DO_NORTE_3441: {
    name: 'Sao Jose do Norte',
    unitId: '3441',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BIOCLINICO_BC_25DEDEZEMBRO_1994: {
    name: 'BC-25 DE DEZEMBRO',
    unitId: '1994',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_BANDEIRANTES_1996: {
    name: 'BC-BANDEIRANTES',
    unitId: '1996',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_CACHOEIRA_1997: {
    name: 'BC-CACHOEIRA',
    unitId: '1997',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_CENTRALBIOCLINICOM_S_1998: {
    name: 'BC-CENTRAL BIOCLINICO MS',
    unitId: '1998',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_EXECUTIVA_2000: {
    name: 'BC-EXECUTIVA',
    unitId: '2000',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_MATOGROSSO_2004: {
    name: 'BC-MATO GROSSO',
    unitId: '2004',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_MORENA_2005: {
    name: 'BC-MORENA',
    unitId: '2005',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_CLINICAPROGENESE_2006: {
    name: 'BC-CLINICA PRO-GENESE',
    unitId: '2006',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BIOCLINICO_BC_TAMANDARE_2009: {
    name: 'BC-TAMANDARÉ',
    unitId: '2009',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SAO_MARCOS_GSM_CENTRO_DE_CONTAGEM_3794: {
    name: 'GSM-CENTRO DE CONTAGEM',
    unitId: '3794',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_RESSACA_3820: {
    name: 'GSM-RESSACA',
    unitId: '3820',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_ELCORDIS_3875: {
    name: 'GSM-ELCORDIS',
    unitId: '3875',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_ELDORADO_3795: {
    name: 'GSM-ELDORADO',
    unitId: '3795',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SANTA_INES_3796: {
    name: 'GSM-SANTA INÊS',
    unitId: '3796',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SANTA_MONICA_3821: {
    name: 'GSM-SANTA MÔNICA',
    unitId: '3821',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SABARA_3822: {
    name: 'GSM-SABARÁ',
    unitId: '3822',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_CENTRO_SAO_MARCOS_3823: {
    name: 'GSM-CENTRO - SÃO MARCOS',
    unitId: '3823',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BARREIRO_3806: {
    name: 'GSM-BARREIRO',
    unitId: '3806',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PADRE_EUSTAQUIO_3824: {
    name: 'GSM-PADRE EUSTÁQUIO',
    unitId: '3824',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_FLORESTA_3825: {
    name: 'GSM-FLORESTA',
    unitId: '3825',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_ALIPIO_DE_MELO_3826: {
    name: 'GSM-ALÍPIO DE MELO',
    unitId: '3826',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_GUARANI_3827: {
    name: 'GSM-GUARANI',
    unitId: '3827',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_GRAJAU_3828: {
    name: 'GSM-GRAJAÚ',
    unitId: '3828',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BETANIA_3829: {
    name: 'GSM-BETÂNIA',
    unitId: '3829',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BARREIRO_DE_CIMA_3830: {
    name: 'GSM-BARREIRO DE CIMA',
    unitId: '3830',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BARREIRO_2_3831: {
    name: 'GSM-BARREIRO 2',
    unitId: '3831',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_CAICARA_3832: {
    name: 'GSM-CAIÇARA',
    unitId: '3832',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PLANALTO_3833: {
    name: 'GSM-PLANALTO',
    unitId: '3833',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_GUTIERREZ_2_3834: {
    name: 'GSM-GUTIERREZ 2',
    unitId: '3834',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_ANCHIETA_3835: {
    name: 'GSM-ANCHIETA',
    unitId: '3835',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_TIROL_3836: {
    name: 'GSM-TIROL',
    unitId: '3836',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BURITIS_3837: {
    name: 'GSM-BURITIS',
    unitId: '3837',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SANTA_EFIGENIA_3838: {
    name: 'GSM-SANTA EFIGÊNIA',
    unitId: '3838',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SANTA_AMELIA_3839: {
    name: 'GSM-SANTA AMÉLIA',
    unitId: '3839',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SILVEIRA_3840: {
    name: 'GSM-SILVEIRA',
    unitId: '3840',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SAO_CAETANO_3841: {
    name: 'GSM-SÃO CAETANO',
    unitId: '3841',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_RIBEIRAO_DAS_NEVES_3842: {
    name: 'GSM-RIBEIRÃO DAS NEVES',
    unitId: '3842',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PALMARES_3843: {
    name: 'GSM-PALMARES',
    unitId: '3843',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SAO_GABRIEL_3844: {
    name: 'GSM-SÃO GABRIEL',
    unitId: '3844',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_IBIRITE_3845: {
    name: 'GSM-IBIRITÉ',
    unitId: '3845',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_CASTELO_3846: {
    name: 'GSM-CASTELO',
    unitId: '3846',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_JOSE_FARIA_DA_ROCHA_3847: {
    name: 'GSM-JOSÉ FARIA DA ROCHA',
    unitId: '3847',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SANTA_LUZIA_2_3848: {
    name: 'GSM-SANTA LUZIA 2',
    unitId: '3848',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SAO_BENEDITO_3850: {
    name: 'GSM-SÃO BENEDITO',
    unitId: '3850',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_FLORAMAR_3851: {
    name: 'GSM-FLORAMAR',
    unitId: '3851',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SAVASSI_3852: {
    name: 'GSM-SAVASSI',
    unitId: '3852',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PRADO_3853: {
    name: 'GSM-PRADO',
    unitId: '3853',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PRUDENTE_DE_MORAIS_3854: {
    name: 'GSM-PRUDENTE DE MORAIS',
    unitId: '3854',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_NOVO_RIACHO_3855: {
    name: 'GSM-NOVO RIACHO',
    unitId: '3855',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_JARDIM_RIACHO_3856: {
    name: 'GSM-JARDIM RIACHO',
    unitId: '3856',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SETE_LAGOAS_2_3857: {
    name: 'GSM-SETE LAGOAS 2',
    unitId: '3857',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_OURO_PRETO_3858: {
    name: 'GSM-OURO PRETO',
    unitId: '3858',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_VENEZA_3859: {
    name: 'GSM-VENEZA',
    unitId: '3859',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_INDUSTRIAL_2_3860: {
    name: 'GSM-INDUSTRIAL 2',
    unitId: '3860',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_SETE_LAGOAS_CANAA_3861: {
    name: 'GSM-SETE LAGOAS CANAÃ',
    unitId: '3861',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_JUSTINOPOLIS_2_3862: {
    name: 'GSM-JUSTINÓPOLIS 2',
    unitId: '3862',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_MANGABEIRAS_2_3804: {
    name: 'GSM-MANGABEIRAS 2',
    unitId: '3804',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_VENDA_NOVA_3_3863: {
    name: 'GSM-VENDA NOVA 3',
    unitId: '3863',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BELVEDERE_3864: {
    name: 'GSM-BELVEDERE',
    unitId: '3864',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_CENTRO_3_SAO_MARCOS_3883: {
    name: 'GSM-CENTRO 3 - SÃO MARCOS',
    unitId: '3883',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_LAGOA_SANTA_3865: {
    name: 'GSM-LAGOA SANTA',
    unitId: '3865',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_IGARAPE_3866: {
    name: 'GSM-IGARAPÉ',
    unitId: '3866',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BICAS_3867: {
    name: 'GSM-BICAS',
    unitId: '3867',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_BETIM_3868: {
    name: 'GSM-BETIM',
    unitId: '3868',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_PAMPULHA_3797: {
    name: 'GSM-PAMPULHA',
    unitId: '3797',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_CIDADE_JARDIM_3870: {
    name: 'GSM-CIDADE JARDIM',
    unitId: '3870',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_BETIM_3801: {
    name: 'GSM-STELLANTIS BETIM',
    unitId: '3801',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_CONTAGEM_3800: {
    name: 'GSM-STELLANTIS CONTAGEM',
    unitId: '3800',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_DOM_JOAQUIM_3799: {
    name: 'GSM-STELLANTIS DOM JOAQUIM',
    unitId: '3799',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_ESTORIL_3802: {
    name: 'GSM-STELLANTIS ESTORIL',
    unitId: '3802',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_FABRICA_I_3803: {
    name: 'GSM-STELLANTIS FÁBRICA I',
    unitId: '3803',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SAO_MARCOS_GSM_STELLANTIS_FABRICA_II_3874: {
    name: 'GSM-STELLANTIS FÁBRICA II',
    unitId: '3874',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BORIS_BERENSTEIN_BB_DERBY_3689: {
    name: 'BB-DERBY',
    unitId: '3689',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BORIS_BERENSTEIN_BB_BOA_VIAGEM_3694: {
    name: 'BB-BOA VIAGEM',
    unitId: '3694',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BORIS_BERENSTEIN_BB_PIEDADE_3690: {
    name: 'BB-PIEDADE',
    unitId: '3690',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BORIS_BERENSTEIN_BB_CABO_STO_AGOSTINHO_3691: {
    name: 'BB-CABO STO AGOSTINHO',
    unitId: '3691',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BORIS_BERENSTEIN_BB_OLINDA_3692: {
    name: 'BB-OLINDA',
    unitId: '3692',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  BORIS_BERENSTEIN_BB_PAULISTA_3693: {
    name: 'BB-PAULISTA',
    unitId: '3693',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  ANTONELLO_GEX_ANTONELLO_ANCHIETA_3443: {
    name: 'GEX-ANTONELLO ANCHIETA',
    unitId: '3443',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ANTONELLO_GEX_ANTONELLO_BENTO_3445: {
    name: 'GEX-ANTONELLO BENTO',
    unitId: '3445',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ANTONELLO_GEX_ANTONELLO_FRAGATA_3446: {
    name: 'GEX-ANTONELLO FRAGATA',
    unitId: '3446',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_BACELLAR_ESTEO_CENTRO_2029: {
    name: 'GEX-BACELLAR ESTEIO CENTRO',
    unitId: '2029',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SAPUCAIA_CENTRO_2228: {
    name: 'GEX-SAPUCAIA CENTRO',
    unitId: '2228',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SANTO_ANTONIO_2227: {
    name: 'GEX-BACELLAR SANTO ANTÔNIO',
    unitId: '2227',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SAPUCAIA_CLINICAS_2229: {
    name: 'GEX-SAPUCAIA CLINICAS',
    unitId: '2229',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SAPUCAIA_X_2230: {
    name: 'GEX-SAPUCAIA X',
    unitId: '2230',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SESMAT_CANOAS_2231: {
    name: 'GEX-SESMAT CANOAS',
    unitId: '2231',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SESMAT_ESTEIO_3554: {
    name: 'GEX-SESMAT ESTEIO',
    unitId: '3554',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  BACELLAR_SESMAT_NH_3686: {
    name: 'GEX-SESMAT NH',
    unitId: '3686',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  CEC_UNIVIDA_2919: {
    name: 'GEX-UNIVIDA',
    unitId: '2919',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  CEC_CEC_MATRIZ_3524: {
    name: 'GEX-CEC MATRIZ',
    unitId: '3524',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  CEC_VACINAS_3529: {
    name: 'GEX-CEC VACINAS',
    unitId: '3529',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  CEC_DOMINGOS_MARTINS_3531: {
    name: 'GEX-CEC-DOMINGOS MARTINS / CLI',
    unitId: '3531',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  CEC_CLINICARE_3532: {
    name: 'GEX-CEC-CLINICARE',
    unitId: '3532',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  EXAME_DO_SUL_GEX_MATRIZ_EXAME_RS_3500: {
    name: 'GEX-MATRIZ EXAME-RS',
    unitId: '3500',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_TUPI_3502: {
    name: 'GEX-TUPI',
    unitId: '3502',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SAO_LEOPOLDO_3506: {
    name: 'GEX-SÃO LEOPOLDO',
    unitId: '3506',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_CAMPO_BOM_3507: {
    name: 'GEX-CAMPO BOM',
    unitId: '3507',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SAO_JOSE_DO_HORTENCIO_3510: {
    name: 'GEX-SÃO JOSÉ DO HORTÊNCIO',
    unitId: '3510',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_CANUDOS_3511: {
    name: 'GEX-CANUDOS',
    unitId: '3511',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_CINCO_DE_ABRIL_3513: {
    name: 'GEX-CINCO DE ABRIL',
    unitId: '3513',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SAO_JOAO_3514: {
    name: 'GEX-SÃO JOÃO',
    unitId: '3514',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_DOM_NOBEL_3548: {
    name: 'GEX-DOM NOBEL',
    unitId: '3548',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SP_OTTO_3560: {
    name: 'GEX-SP OTTO',
    unitId: '3560',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_NILO_PECANHA_3583: {
    name: 'GEX-NILO PEÇANHA',
    unitId: '3583',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_PASEO_TREND_3556: {
    name: 'GEX-PASEO TREND',
    unitId: '3556',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_INNOVA_3555: {
    name: 'GEX-INNOVA',
    unitId: '3555',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SESMAT_GRAVATAI_3681: {
    name: 'GEX-SESMAT GRAVATAÍ',
    unitId: '3681',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_SESMAT_SAPUCAIA_3675: {
    name: 'GEX-SESMAT SAPUCAIA',
    unitId: '3675',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  EXAME_DO_SUL_GEX_CENTRO_CLINICO_EXAME_RS_SUBSOLO_3589: {
    name: 'GEX-CENTRO CLÍNICO EXAME-RS - SUBSOLO',
    unitId: '3589',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_ESTREITO_3949: {
    name: 'SL-ESTREITO',
    unitId: '3949',
    serviceDesk: 'SZT',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_JERONIMO_COELHO_3953: {
    name: 'SL-JERÔNIMO COELHO',
    unitId: '3953',
    serviceDesk: 'SLJ',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_MADRE_BENVENUTA_3954: {
    name: 'SL-MADRE BENVENUTA',
    unitId: '3954',
    serviceDesk: 'SMV',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_PEDRA_BRANCA_3969: {
    name: 'SL-PEDRA BRANCA',
    unitId: '3969',
    serviceDesk: 'STP',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_PADRE_ROMA_3974: {
    name: 'SL-PADRE ROMA',
    unitId: '3974',
    serviceDesk: 'SRO',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_GAROPABA_3976: {
    name: 'SL-GAROPABA',
    unitId: '3976',
    serviceDesk: 'SNG',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_SUL_DA_ILHA_3967: {
    name: 'SL-SUL DA ILHA',
    unitId: '3967',
    serviceDesk: 'SIH',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_COQUEIROS_3970: {
    name: 'SL-COQUEIROS',
    unitId: '3970',
    serviceDesk: 'SLQ',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_CANASVIEIRAS_3971: {
    name: 'SL-CANASVIEIRAS',
    unitId: '3971',
    serviceDesk: 'SLV',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_CAMPINAS_3959: {
    name: 'SL-CAMPINAS',
    unitId: '3959',
    serviceDesk: 'SLP',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_SUL_DA_ILHA_DOM_FRANQUIA_3980: {
    name: 'SL-SUL DA ILHA DOM FRANQUIA',
    unitId: '3980',
    serviceDesk: 'SDD',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_MATRIZ_SANTA_3950: {
    name: 'SL-MATRIZ SANTA',
    unitId: '3950',
    serviceDesk: 'STZ',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_INGLESES_3955: {
    name: 'SL-INGLESES',
    unitId: '3955',
    serviceDesk: 'SI1',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_TIJUCAS_3961: {
    name: 'SL-TIJUCAS',
    unitId: '3961',
    serviceDesk: 'SLT',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_PRAIA_COMPRIDA_3963: {
    name: 'SL-PRAIA COMPRIDA',
    unitId: '3963',
    serviceDesk: 'SLN',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_BIGUACU_3965: {
    name: 'SL-BIGUAÇU',
    unitId: '3965',
    serviceDesk: 'SGC',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_ITACORUBI_3972: {
    name: 'SL-ITACORUBI',
    unitId: '3972',
    serviceDesk: 'SZI',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_SACO_DOS_LIMOES_3977: {
    name: 'SL-SACO DOS LIMOES',
    unitId: '3977',
    serviceDesk: 'SSO',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  SANTALUZIA_SL_JURERE_3957: {
    name: 'SL-JURERÊ',
    unitId: '3957',
    serviceDesk: 'SLR',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_BARREIROS_3964: {
    name: 'SL-BARREIROS',
    unitId: '3964',
    serviceDesk: 'SRR',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_ANGELONI_CAPOEIRAS_3951: {
    name: 'SL-ANGELONI CAPOEIRAS',
    unitId: '3951',
    serviceDesk: 'SAG',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_TIJUCAS_DOM_FRANQUIA_3979: {
    name: 'SL-TIJUCAS DOM FRANQUIA',
    unitId: '3979',
    serviceDesk: 'SJI',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_COQUEIROS_DOM_FRANQUIA_3981: {
    name: 'SL-COQUEIROS DOM FRANQUIA',
    unitId: '3981',
    serviceDesk: 'SQD',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_CANASVIEIRAS_DOM_FRANQUIA_3982: {
    name: 'SL-CANASVIEIRAS DOM FRANQUIA',
    unitId: '3982',
    serviceDesk: 'SNV',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_FORQUILHINHAS_3975: {
    name: 'SL-FORQUILHINHAS',
    unitId: '3975',
    serviceDesk: 'SFQ',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_KOBRASOL_3952: {
    name: 'SL-KOBRASOL',
    unitId: '3952',
    serviceDesk: 'SLK',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_LAGOA_3966: {
    name: 'SL-LAGOA',
    unitId: '3966',
    serviceDesk: 'SOA',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_LAURO_LINHARES_3958: {
    name: 'SL-LAURO LINHARES',
    unitId: '3958',
    serviceDesk: 'SLO',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_PALHOCA_3962: {
    name: 'SL-PALHOÇA',
    unitId: '3962',
    serviceDesk: 'SHO',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_PAGANI_3968: {
    name: 'SL-PAGANI',
    unitId: '3968',
    serviceDesk: 'STG',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTALUZIA_SL_CAMPECHE_3973: {
    name: 'SL-CAMPECHE',
    unitId: '3973',
    serviceDesk: 'SZH',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SANTA_LUZIA_HOSPITAL_CARIDADE_3999: {
    name: 'Hospital Caridade - Unidade Ambulatorial',
    unitId: '3999',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_IBCM_IMBE_3551: {
    name: 'GEX-IMBÉ',
    unitId: '3551',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_IBCM_MENINO_DEUS_3552: {
    name: 'GEX-IBCM MENINO DEUS',
    unitId: '3552',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_IBCM_PARTENON_3553: {
    name: 'GEX-IBCM PARTENON',
    unitId: '3553',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_JJ_POA_3546: {
    name: 'GEX-JJ POA',
    unitId: '3546',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_JJ_CACHOEIRINHA_3558: {
    name: 'GEX-JJ CACHOEIRINHA',
    unitId: '3558',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_JJ_CANOAS_3561: {
    name: 'GEX-JJ CANOAS',
    unitId: '3561',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_CAVALHADA_3563: {
    name: 'GEX-CAVALHADA',
    unitId: '3563',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_OBIRICI_3564: {
    name: 'GEX-OBIRICI',
    unitId: '3564',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_ALVORADA_3565: {
    name: 'GEX-ALVORADA',
    unitId: '3565',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_STRIP_CENTER_3566: {
    name: 'GEX-STRIP CENTER',
    unitId: '3566',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_RESTINGA_3567: {
    name: 'GEX-RESTINGA',
    unitId: '3567',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_MATHIAS_3569: {
    name: 'GEX-MATHIAS',
    unitId: '3569',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_BENTO_3571: {
    name: 'GEX-BENTO',
    unitId: '3571',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SOS_BALTAZAR_3572: {
    name: 'GEX-SOS BALTAZAR',
    unitId: '3572',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_ADVENTISTA_3573: {
    name: 'GEX-ADVENTISTA',
    unitId: '3573',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SP_CACHOEIRINHA_CENTRO_3575: {
    name: 'GEX-SP CACHOEIRINHA CENTRO',
    unitId: '3575',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_BIG_ALVORADA_3576: {
    name: 'GEX-BIG ALVORADA',
    unitId: '3576',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SESMAT_POA_3579: {
    name: 'GEX-SESMAT POA',
    unitId: '3579',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SOS_ASSIS_BRASIL_3584: {
    name: 'GEX-SOS ASSIS BRASIL',
    unitId: '3584',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_ASSIS_BRASIL_3627: {
    name: 'GEX-SALUTE ASSIS BRASIL',
    unitId: '3627',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_CENTRO_3629: {
    name: 'GEX-SALUTE CENTRO',
    unitId: '3629',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_RESTINGA_3630: {
    name: 'GEX-SALUTE RESTINGA',
    unitId: '3630',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_CANOAS_3647: {
    name: 'GEX-SALUTE CANOAS',
    unitId: '3647',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_GRAVATAI_3648: {
    name: 'GEX-SALUTE GRAVATAI',
    unitId: '3648',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },

  SENHOR_DOS_PASSOS_SALUTE_ALVORADA_3649: {
    name: 'GEX-SALUTE ALVORADA',
    unitId: '3649',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
  ELCORDIS_ELCORDIS_CD_3742: {
    name: 'GSM-ELCORDIS CD',
    unitId: '3742',
    serviceDesk: '',
    tracking: false,
    endFlowMessage: 'Retire uma senha de Check-in para finalizar seu atendimento',
    magicTv: false,
    uploadExams: true,
  },
});
